import i18n from './i18n';

// P2.A2 branch-seo: per-city per-branch landing and directory keys
// Auto-generated from city + branch configuration

const deResources = {
  cleaningHamburgLanding: {
    metaTitle: 'Reinigung Hamburg | RegionalUmzug24 – Reinigungsfirmen vergleichen',
    metaDescription:
      'Finden Sie geprüfte Reinigungsfirmen in Hamburg. Kostenlos Angebote von verifizierten Hamburger Reinigungsfirmen vergleichen – Erfahrung mit Hafen, Elbe und Speicherstadt.',
    metaKeywords: 'Reinigung Hamburg, Reinigungsfirma Hamburg, Reinigungskosten Hamburg',
    heroTitleStart: 'Ihre Reinigung in',
    heroTitleHighlight: 'Hamburg.',
    heroSubtitle:
      'Vergleichen Sie kostenlos geprüfte Hamburger Reinigungsfirmen – schnell, diskret und mit Erfahrung für Hafen, Elbe und Speicherstadt.',
    heroCtaPrimary: 'Jetzt Angebote erhalten',
    heroCtaSecondary: 'Hamburger Firmen ansehen',
    heroStatFirms: '140+ Hamburger Firmen',
    heroStatMoves: '280+ vermittelte Aufträge',
    heroStatRating: '4,8/5 Bewertung',
    benefitsTitle: 'Ihre Vorteile mit RegionalUmzug24 für Reinigung in Hamburg',
    benefitsSubtitle:
      'Warum sich Hamburger Kund:innen für unsere Vermittlungsplattform entscheiden',
    benefitFreeTitle: '100 % kostenlos',
    benefitFreeDesc: 'Anfrage und Vergleich sind für Sie komplett kostenfrei und unverbindlich.',
    benefitVettedTitle: 'Geprüfte Reinigungskräfte',
    benefitVettedDesc:
      'Wir vermitteln ausschließlich geprüfte Hamburger Reinigungsfirmen mit Versicherung und Fachnachweis.',
    benefitFastTitle: 'Schnelle Termine',
    benefitFastDesc:
      'Erhalten Sie Angebote innerhalb von 24 Stunden und buchen Sie Ihren Wunschtermin – auch kurzfristig.',
    servicesTitle: 'Unsere Reinigung-Services in Hamburg',
    servicesSubtitle: 'Welche Art von Reinigung benötigen Sie in Hamburg?',
    serviceApartmentTitle: 'Wohnungsreinigung',
    serviceApartmentDesc:
      'Gründliche Reinigung Ihrer Wohnung – perfekt vor oder nach einem Umzug in Hamburg.',
    serviceSecondaryTitle: 'Büroreinigung',
    serviceSecondaryDesc:
      'Regelmäßige oder einmalige professionelle Reinigung Ihres Büros oder Ihrer Praxis in Hamburg.',
    serviceThirdTitle: 'Endreinigung',
    serviceThirdDesc:
      'Besenreine Übergabe Ihrer Wohnung in Hamburg inkl. Abnahmegarantie mit dem Vermieter.',
    serviceFourthTitle: 'Fensterreinigung',
    serviceFourthDesc:
      'Streifenfreie Fenster, Rahmen und Fensterbänke in Hamburg – auch in schwer zugänglichen Höhen.',
    processTitle: 'So läuft Ihre Reinigung in Hamburg ab',
    processSubtitle: 'In drei einfachen Schritten zu Ihrer passenden Reinigungsfirma in Hamburg',
    step1Title: 'Anfrage stellen',
    step1Desc: 'Beschreiben Sie Ihr Anliegen in Hamburg in wenigen Schritten online.',
    step2Title: 'Hamburger Firmen erhalten',
    step2Desc: 'Passende Reinigungsfirmen aus Hamburg senden Ihnen ihre Angebote.',
    step3Title: 'Firma wählen',
    step3Desc: 'Vergleichen Sie Bewertungen und wählen Sie das beste Angebot in Hamburg.',
    statsTitle: 'Reinigung in Hamburg in Zahlen',
    statsSubtitle: 'Vertrauen der Hamburger Kund:innen auf RegionalUmzug24',
    statFirms: '140+',
    statFirmsLabel: 'Hamburger Reinigungsfirmen',
    statJobs: '280+',
    statJobsLabel: 'Vermittelte Aufträge',
    statRating: '4,8/5',
    statRatingLabel: 'Kundenbewertung',
    trustTitle: 'Geprüfte Hamburger Reinigungsfirmen',
    trustSubtitle: 'Sicherheit und Qualität – speziell für Hamburg',
    trustVerifiedTitle: 'Verifizierte Hamburger Firmen',
    trustVerifiedDesc:
      'Jede Firma wird auf Gewerbeanmeldung, Versicherung und Reinigung-Erfahrung geprüft.',
    trustGdprTitle: 'DSGVO-konform',
    trustGdprDesc: 'Ihre Daten werden verschlüsselt übertragen und nicht an Dritte weitergegeben.',
    trustFreeTitle: '100 % kostenlos',
    trustFreeDesc:
      'Die Nutzung von RegionalUmzug24 ist für Sie komplett kostenfrei – ohne versteckte Gebühren.',
    faqTitle: 'Häufige Fragen zur Reinigung in Hamburg',
    faqSubtitle: 'Antworten auf die wichtigsten Fragen rund um Reinigung in Hamburg',
    faq1Question: 'Was kostet eine Reinigung in Hamburg?',
    faq1Answer:
      'Die Kosten hängen von Größe, Zustand und Art der Reinigung ab. Über uns erhalten Sie kostenlos vergleichbare Angebote aus Hamburg.',
    faq2Question: 'Sind die Reinigungsfirmen in Hamburg versichert?',
    faq2Answer:
      'Ja, alle vermittelten {cityAdj} Reinigungsfirmen sind geprüft und haftpflichtversichert. So sind Sie bei eventuellen Schäden abgesichert.',
    faq3Question: 'Wie schnell bekomme ich Angebote aus Hamburg?',
    faq3Answer:
      'In der Regel erhalten Sie innerhalb von 24 Stunden die ersten Angebote von passenden Reinigungsfirmen in Hamburg und Umgebung.',
    faq4Question: 'Kann ich kurzfristig eine Reinigung in Hamburg buchen?',
    faq4Answer:
      'Ja, viele Reinigungsfirmen in Hamburg bieten auch kurzfristige Termine an. Geben Sie Ihren Wunschtermin einfach in der Anfrage an.',
    faq5Question: 'Welche Reinigungsleistungen werden in Hamburg angeboten?',
    faq5Answer:
      'Von der Wohnungsreinigung über die Büroreinigung bis zur Fenster- und Teppichreinigung – die vermittelten Firmen decken das gesamte Spektrum ab.',
    ctaTitle: 'Bereit für Ihre Reinigung in Hamburg?',
    ctaSubtitle:
      'Erstellen Sie jetzt kostenlos Ihre Anfrage und erhalten Sie Angebote von geprüften Hamburger Reinigungsfirmen.',
    ctaPrimary: 'Jetzt Anfrage erstellen',
    ctaSecondary: 'Hamburger Firmen ansehen',
  },
  cleaningHamburgDirectory: {
    metaTitle: 'Reinigungsfirmen Hamburg | RegionalUmzug24 – Hamburger Firmen vergleichen',
    metaDescription:
      'Liste geprüfter Reinigungsfirmen in Hamburg. Vergleichen Sie Bewertungen, Spezialgebiete und Preise von hamburger Reinigungsfirmen im PLZ-Bereich 20-22.',
    metaKeywords: 'Reinigungsfirmen Hamburg, hamburger Reinigungsfirma, Reinigungs Hamburg Firmen',
    pageTitle: 'Reinigungsfirmen in Hamburg',
    pageSubtitle:
      'Entdecken Sie geprüfte hamburger Reinigungsfirmen mit echten Bewertungen. PLZ-Bereich 20-22 – abgestimmt auf Hamburg.',
    filterTitle: 'Filter',
    filterPremium: 'Nur Premium-Firmen',
    filterVerified: 'Nur verifizierte Firmen',
    filterPostalTitle: 'PLZ-Bereich',
    filterPostalAll: 'Alle PLZ-Bereiche',
    sortTitle: 'Sortierung',
    sortRating: 'Beste Bewertung',
    sortOrders: 'Meiste Aufträge',
    sortNewest: 'Neueste',
    resultCount: '{{count}} Firmen gefunden',
    emptyTitle: 'Keine Firmen gefunden',
    emptyDescription:
      'Mit den aktuellen Filtern wurden keine hamburger Reinigungsfirmen gefunden. Versuchen Sie, die Filter anzupassen.',
    emptyReset: 'Filter zurücksetzen',
    loadingTitle: 'Lade hamburger Reinigungsfirmen...',
    errorTitle: 'Fehler beim Laden',
    errorDescription:
      'Die Liste der hamburger Reinigungsfirmen konnte nicht geladen werden. Bitte versuchen Sie es erneut.',
    errorRetry: 'Erneut versuchen',
    paginationPrev: 'Zurück',
    paginationNext: 'Weiter',
    paginationPage: 'Seite {{page}} von {{total}}',
    filterPostal20: 'PLZ 20 (Innenstadt)',
    filterPostal21: 'PLZ 21 (Norden)',
    filterPostal22: 'PLZ 22 (Osten)',
  },
  disposalHamburgLanding: {
    metaTitle:
      'Entrümpelung & Entsorgung Hamburg | RegionalUmzug24 – Entrümpelungsfirmen vergleichen',
    metaDescription:
      'Finden Sie geprüfte Entrümpelungsfirmen in Hamburg. Kostenlos Angebote von verifizierten Hamburger Entrümpelungsfirmen vergleichen – Erfahrung mit Hafen, Elbe und Speicherstadt.',
    metaKeywords:
      'Entrümpelung & Entsorgung Hamburg, Entrümpelungsfirma Hamburg, Entrümpelungskosten Hamburg',
    heroTitleStart: 'Ihre Entrümpelung & Entsorgung in',
    heroTitleHighlight: 'Hamburg.',
    heroSubtitle:
      'Vergleichen Sie kostenlos geprüfte Hamburger Entrümpelungsfirmen – schnell, diskret und mit Erfahrung für Hafen, Elbe und Speicherstadt.',
    heroCtaPrimary: 'Jetzt Angebote erhalten',
    heroCtaSecondary: 'Hamburger Firmen ansehen',
    heroStatFirms: '110+ Hamburger Firmen',
    heroStatMoves: '230+ vermittelte Aufträge',
    heroStatRating: '4,7/5 Bewertung',
    benefitsTitle: 'Ihre Vorteile mit RegionalUmzug24 für Entrümpelung & Entsorgung in Hamburg',
    benefitsSubtitle:
      'Warum sich Hamburger Kund:innen für unsere Vermittlungsplattform entscheiden',
    benefitFreeTitle: '100 % kostenlos',
    benefitFreeDesc: 'Anfrage und Vergleich sind für Sie komplett kostenfrei und unverbindlich.',
    benefitVettedTitle: 'Geprüfte Entsorgungsbetriebe',
    benefitVettedDesc:
      'Wir vermitteln ausschließlich geprüfte Hamburger Entrümpelungsfirmen mit Versicherung und Fachnachweis.',
    benefitFastTitle: 'Schnelle Termine',
    benefitFastDesc:
      'Erhalten Sie Angebote innerhalb von 24 Stunden und buchen Sie Ihren Wunschtermin – auch kurzfristig.',
    servicesTitle: 'Unsere Entrümpelung & Entsorgung-Services in Hamburg',
    servicesSubtitle: 'Welche Art von Entrümpelung benötigen Sie in Hamburg?',
    serviceApartmentTitle: 'Wohnungsauflösung',
    serviceApartmentDesc:
      'Komplette oder teilweise Auflösung Ihrer Wohnung in Hamburg inkl. fachgerechter Entsorgung.',
    serviceSecondaryTitle: 'Haushaltsauflösung',
    serviceSecondaryDesc:
      'Auflösung ganzer Haushalte in Hamburg – einfühlsam, diskret und mit Entsorgungsnachweis.',
    serviceThirdTitle: 'Keller- & Dachbodenentrümpelung',
    serviceThirdDesc:
      'Endlich wieder Platz in Keller und Dachboden in Hamburg – inkl. Sperrmüll- und Sondermüllabholung.',
    serviceFourthTitle: 'Gartenentrümpelung',
    serviceFourthDesc:
      'Entfernung von Gartenabfällen, alten Möbeln und Bauschutt in Hamburg – inkl. Abtransport.',
    processTitle: 'So läuft Ihre Entrümpelung & Entsorgung in Hamburg ab',
    processSubtitle: 'In drei einfachen Schritten zu Ihrer passenden Entrümpelungsfirma in Hamburg',
    step1Title: 'Anfrage stellen',
    step1Desc: 'Beschreiben Sie Ihr Anliegen in Hamburg in wenigen Schritten online.',
    step2Title: 'Hamburger Firmen erhalten',
    step2Desc: 'Passende Entrümpelungsfirmen aus Hamburg senden Ihnen ihre Angebote.',
    step3Title: 'Firma wählen',
    step3Desc: 'Vergleichen Sie Bewertungen und wählen Sie das beste Angebot in Hamburg.',
    statsTitle: 'Entrümpelung & Entsorgung in Hamburg in Zahlen',
    statsSubtitle: 'Vertrauen der Hamburger Kund:innen auf RegionalUmzug24',
    statFirms: '110+',
    statFirmsLabel: 'Hamburger Entrümpelungsfirmen',
    statJobs: '230+',
    statJobsLabel: 'Vermittelte Aufträge',
    statRating: '4,7/5',
    statRatingLabel: 'Kundenbewertung',
    trustTitle: 'Geprüfte Hamburger Entrümpelungsfirmen',
    trustSubtitle: 'Sicherheit und Qualität – speziell für Hamburg',
    trustVerifiedTitle: 'Verifizierte Hamburger Firmen',
    trustVerifiedDesc:
      'Jede Firma wird auf Gewerbeanmeldung, Versicherung und Entrümpelung-Erfahrung geprüft.',
    trustGdprTitle: 'DSGVO-konform',
    trustGdprDesc: 'Ihre Daten werden verschlüsselt übertragen und nicht an Dritte weitergegeben.',
    trustFreeTitle: '100 % kostenlos',
    trustFreeDesc:
      'Die Nutzung von RegionalUmzug24 ist für Sie komplett kostenfrei – ohne versteckte Gebühren.',
    faqTitle: 'Häufige Fragen zur Entrümpelung & Entsorgung in Hamburg',
    faqSubtitle:
      'Antworten auf die wichtigsten Fragen rund um Entrümpelung & Entsorgung in Hamburg',
    faq1Question: 'Was kostet eine Entrümpelung in Hamburg?',
    faq1Answer:
      'Die Kosten hängen von Volumen, Stockwerk und Entsorgungsart ab. Über uns erhalten Sie kostenlos vergleichbare Angebote aus Hamburg.',
    faq2Question: 'Werden die Sachen in Hamburg fachgerecht entsorgt?',
    faq2Answer:
      'Ja, alle vermittelten {cityAdj} Firmen entsorgen fachgerecht mit Nachweis. Wertstoffe werden recycelt, Restmüll ordnungsgemäß entsorgt.',
    faq3Question: 'Wie schnell geht eine Entrümpelung in Hamburg?',
    faq3Answer:
      'In der Regel erhalten Sie innerhalb von 24 Stunden die ersten Angebote. Viele {cityAdj} Firmen bieten Termine innerhalb weniger Tage an.',
    faq4Question: 'Kann ich auch nur einzelne Räume in Hamburg entrümpeln lassen?',
    faq4Answer:
      'Ja, Sie können die Anfrage auf einzelne Räume, Keller oder Dachboden in Hamburg beschränken – die Firmen erstellen ein passendes Angebot.',
    faq5Question: 'Was passiert mit verwertbaren Gegenständen in Hamburg?',
    faq5Answer:
      'Wertvolle oder verwertbare Gegenstände können vorab aussortiert werden. Klären Sie Details direkt mit der gewählten {cityAdj} Firma.',
    ctaTitle: 'Bereit für Ihre Entrümpelung & Entsorgung in Hamburg?',
    ctaSubtitle:
      'Erstellen Sie jetzt kostenlos Ihre Anfrage und erhalten Sie Angebote von geprüften Hamburger Entrümpelungsfirmen.',
    ctaPrimary: 'Jetzt Anfrage erstellen',
    ctaSecondary: 'Hamburger Firmen ansehen',
  },
  disposalHamburgDirectory: {
    metaTitle: 'Entrümpelungsfirmen Hamburg | RegionalUmzug24 – Hamburger Firmen vergleichen',
    metaDescription:
      'Liste geprüfter Entrümpelungsfirmen in Hamburg. Vergleichen Sie Bewertungen, Spezialgebiete und Preise von hamburger Entrümpelungsfirmen im PLZ-Bereich 20-22.',
    metaKeywords:
      'Entrümpelungsfirmen Hamburg, hamburger Entrümpelungsfirma, Entrümpelungs Hamburg Firmen',
    pageTitle: 'Entrümpelungsfirmen in Hamburg',
    pageSubtitle:
      'Entdecken Sie geprüfte hamburger Entrümpelungsfirmen mit echten Bewertungen. PLZ-Bereich 20-22 – abgestimmt auf Hamburg.',
    filterTitle: 'Filter',
    filterPremium: 'Nur Premium-Firmen',
    filterVerified: 'Nur verifizierte Firmen',
    filterPostalTitle: 'PLZ-Bereich',
    filterPostalAll: 'Alle PLZ-Bereiche',
    sortTitle: 'Sortierung',
    sortRating: 'Beste Bewertung',
    sortOrders: 'Meiste Aufträge',
    sortNewest: 'Neueste',
    resultCount: '{{count}} Firmen gefunden',
    emptyTitle: 'Keine Firmen gefunden',
    emptyDescription:
      'Mit den aktuellen Filtern wurden keine hamburger Entrümpelungsfirmen gefunden. Versuchen Sie, die Filter anzupassen.',
    emptyReset: 'Filter zurücksetzen',
    loadingTitle: 'Lade hamburger Entrümpelungsfirmen...',
    errorTitle: 'Fehler beim Laden',
    errorDescription:
      'Die Liste der hamburger Entrümpelungsfirmen konnte nicht geladen werden. Bitte versuchen Sie es erneut.',
    errorRetry: 'Erneut versuchen',
    paginationPrev: 'Zurück',
    paginationNext: 'Weiter',
    paginationPage: 'Seite {{page}} von {{total}}',
    filterPostal20: 'PLZ 20 (Innenstadt)',
    filterPostal21: 'PLZ 21 (Norden)',
    filterPostal22: 'PLZ 22 (Osten)',
  },
  cleaningMunchenLanding: {
    metaTitle: 'Reinigung München | RegionalUmzug24 – Reinigungsfirmen vergleichen',
    metaDescription:
      'Finden Sie geprüfte Reinigungsfirmen in München. Kostenlos Angebote von verifizierten Münchner Reinigungsfirmen vergleichen – Erfahrung mit Maxvorstadt, Schwabing und Münchner Umland.',
    metaKeywords: 'Reinigung München, Reinigungsfirma München, Reinigungskosten München',
    heroTitleStart: 'Ihre Reinigung in',
    heroTitleHighlight: 'München.',
    heroSubtitle:
      'Vergleichen Sie kostenlos geprüfte Münchner Reinigungsfirmen – schnell, diskret und mit Erfahrung für Maxvorstadt, Schwabing und Münchner Umland.',
    heroCtaPrimary: 'Jetzt Angebote erhalten',
    heroCtaSecondary: 'Münchner Firmen ansehen',
    heroStatFirms: '140+ Münchner Firmen',
    heroStatMoves: '280+ vermittelte Aufträge',
    heroStatRating: '4,8/5 Bewertung',
    benefitsTitle: 'Ihre Vorteile mit RegionalUmzug24 für Reinigung in München',
    benefitsSubtitle: 'Warum sich Münchner Kund:innen für unsere Vermittlungsplattform entscheiden',
    benefitFreeTitle: '100 % kostenlos',
    benefitFreeDesc: 'Anfrage und Vergleich sind für Sie komplett kostenfrei und unverbindlich.',
    benefitVettedTitle: 'Geprüfte Reinigungskräfte',
    benefitVettedDesc:
      'Wir vermitteln ausschließlich geprüfte Münchner Reinigungsfirmen mit Versicherung und Fachnachweis.',
    benefitFastTitle: 'Schnelle Termine',
    benefitFastDesc:
      'Erhalten Sie Angebote innerhalb von 24 Stunden und buchen Sie Ihren Wunschtermin – auch kurzfristig.',
    servicesTitle: 'Unsere Reinigung-Services in München',
    servicesSubtitle: 'Welche Art von Reinigung benötigen Sie in München?',
    serviceApartmentTitle: 'Wohnungsreinigung',
    serviceApartmentDesc:
      'Gründliche Reinigung Ihrer Wohnung – perfekt vor oder nach einem Umzug in München.',
    serviceSecondaryTitle: 'Büroreinigung',
    serviceSecondaryDesc:
      'Regelmäßige oder einmalige professionelle Reinigung Ihres Büros oder Ihrer Praxis in München.',
    serviceThirdTitle: 'Endreinigung',
    serviceThirdDesc:
      'Besenreine Übergabe Ihrer Wohnung in München inkl. Abnahmegarantie mit dem Vermieter.',
    serviceFourthTitle: 'Fensterreinigung',
    serviceFourthDesc:
      'Streifenfreie Fenster, Rahmen und Fensterbänke in München – auch in schwer zugänglichen Höhen.',
    processTitle: 'So läuft Ihre Reinigung in München ab',
    processSubtitle: 'In drei einfachen Schritten zu Ihrer passenden Reinigungsfirma in München',
    step1Title: 'Anfrage stellen',
    step1Desc: 'Beschreiben Sie Ihr Anliegen in München in wenigen Schritten online.',
    step2Title: 'Münchner Firmen erhalten',
    step2Desc: 'Passende Reinigungsfirmen aus München senden Ihnen ihre Angebote.',
    step3Title: 'Firma wählen',
    step3Desc: 'Vergleichen Sie Bewertungen und wählen Sie das beste Angebot in München.',
    statsTitle: 'Reinigung in München in Zahlen',
    statsSubtitle: 'Vertrauen der Münchner Kund:innen auf RegionalUmzug24',
    statFirms: '140+',
    statFirmsLabel: 'Münchner Reinigungsfirmen',
    statJobs: '280+',
    statJobsLabel: 'Vermittelte Aufträge',
    statRating: '4,8/5',
    statRatingLabel: 'Kundenbewertung',
    trustTitle: 'Geprüfte Münchner Reinigungsfirmen',
    trustSubtitle: 'Sicherheit und Qualität – speziell für München',
    trustVerifiedTitle: 'Verifizierte Münchner Firmen',
    trustVerifiedDesc:
      'Jede Firma wird auf Gewerbeanmeldung, Versicherung und Reinigung-Erfahrung geprüft.',
    trustGdprTitle: 'DSGVO-konform',
    trustGdprDesc: 'Ihre Daten werden verschlüsselt übertragen und nicht an Dritte weitergegeben.',
    trustFreeTitle: '100 % kostenlos',
    trustFreeDesc:
      'Die Nutzung von RegionalUmzug24 ist für Sie komplett kostenfrei – ohne versteckte Gebühren.',
    faqTitle: 'Häufige Fragen zur Reinigung in München',
    faqSubtitle: 'Antworten auf die wichtigsten Fragen rund um Reinigung in München',
    faq1Question: 'Was kostet eine Reinigung in München?',
    faq1Answer:
      'Die Kosten hängen von Größe, Zustand und Art der Reinigung ab. Über uns erhalten Sie kostenlos vergleichbare Angebote aus München.',
    faq2Question: 'Sind die Reinigungsfirmen in München versichert?',
    faq2Answer:
      'Ja, alle vermittelten {cityAdj} Reinigungsfirmen sind geprüft und haftpflichtversichert. So sind Sie bei eventuellen Schäden abgesichert.',
    faq3Question: 'Wie schnell bekomme ich Angebote aus München?',
    faq3Answer:
      'In der Regel erhalten Sie innerhalb von 24 Stunden die ersten Angebote von passenden Reinigungsfirmen in München und Umgebung.',
    faq4Question: 'Kann ich kurzfristig eine Reinigung in München buchen?',
    faq4Answer:
      'Ja, viele Reinigungsfirmen in München bieten auch kurzfristige Termine an. Geben Sie Ihren Wunschtermin einfach in der Anfrage an.',
    faq5Question: 'Welche Reinigungsleistungen werden in München angeboten?',
    faq5Answer:
      'Von der Wohnungsreinigung über die Büroreinigung bis zur Fenster- und Teppichreinigung – die vermittelten Firmen decken das gesamte Spektrum ab.',
    ctaTitle: 'Bereit für Ihre Reinigung in München?',
    ctaSubtitle:
      'Erstellen Sie jetzt kostenlos Ihre Anfrage und erhalten Sie Angebote von geprüften Münchner Reinigungsfirmen.',
    ctaPrimary: 'Jetzt Anfrage erstellen',
    ctaSecondary: 'Münchner Firmen ansehen',
  },
  cleaningMunchenDirectory: {
    metaTitle: 'Reinigungsfirmen München | RegionalUmzug24 – Münchner Firmen vergleichen',
    metaDescription:
      'Liste geprüfter Reinigungsfirmen in München. Vergleichen Sie Bewertungen, Spezialgebiete und Preise von münchner Reinigungsfirmen im PLZ-Bereich 80-81.',
    metaKeywords: 'Reinigungsfirmen München, münchner Reinigungsfirma, Reinigungs München Firmen',
    pageTitle: 'Reinigungsfirmen in München',
    pageSubtitle:
      'Entdecken Sie geprüfte münchner Reinigungsfirmen mit echten Bewertungen. PLZ-Bereich 80-81 – abgestimmt auf München.',
    filterTitle: 'Filter',
    filterPremium: 'Nur Premium-Firmen',
    filterVerified: 'Nur verifizierte Firmen',
    filterPostalTitle: 'PLZ-Bereich',
    filterPostalAll: 'Alle PLZ-Bereiche',
    sortTitle: 'Sortierung',
    sortRating: 'Beste Bewertung',
    sortOrders: 'Meiste Aufträge',
    sortNewest: 'Neueste',
    resultCount: '{{count}} Firmen gefunden',
    emptyTitle: 'Keine Firmen gefunden',
    emptyDescription:
      'Mit den aktuellen Filtern wurden keine münchner Reinigungsfirmen gefunden. Versuchen Sie, die Filter anzupassen.',
    emptyReset: 'Filter zurücksetzen',
    loadingTitle: 'Lade münchner Reinigungsfirmen...',
    errorTitle: 'Fehler beim Laden',
    errorDescription:
      'Die Liste der münchner Reinigungsfirmen konnte nicht geladen werden. Bitte versuchen Sie es erneut.',
    errorRetry: 'Erneut versuchen',
    paginationPrev: 'Zurück',
    paginationNext: 'Weiter',
    paginationPage: 'Seite {{page}} von {{total}}',
    filterPostal80: 'PLZ 80 (Innenstadt)',
    filterPostal81: 'PLZ 81 (Umland)',
  },
  disposalMunchenLanding: {
    metaTitle:
      'Entrümpelung & Entsorgung München | RegionalUmzug24 – Entrümpelungsfirmen vergleichen',
    metaDescription:
      'Finden Sie geprüfte Entrümpelungsfirmen in München. Kostenlos Angebote von verifizierten Münchner Entrümpelungsfirmen vergleichen – Erfahrung mit Maxvorstadt, Schwabing und Münchner Umland.',
    metaKeywords:
      'Entrümpelung & Entsorgung München, Entrümpelungsfirma München, Entrümpelungskosten München',
    heroTitleStart: 'Ihre Entrümpelung & Entsorgung in',
    heroTitleHighlight: 'München.',
    heroSubtitle:
      'Vergleichen Sie kostenlos geprüfte Münchner Entrümpelungsfirmen – schnell, diskret und mit Erfahrung für Maxvorstadt, Schwabing und Münchner Umland.',
    heroCtaPrimary: 'Jetzt Angebote erhalten',
    heroCtaSecondary: 'Münchner Firmen ansehen',
    heroStatFirms: '110+ Münchner Firmen',
    heroStatMoves: '230+ vermittelte Aufträge',
    heroStatRating: '4,7/5 Bewertung',
    benefitsTitle: 'Ihre Vorteile mit RegionalUmzug24 für Entrümpelung & Entsorgung in München',
    benefitsSubtitle: 'Warum sich Münchner Kund:innen für unsere Vermittlungsplattform entscheiden',
    benefitFreeTitle: '100 % kostenlos',
    benefitFreeDesc: 'Anfrage und Vergleich sind für Sie komplett kostenfrei und unverbindlich.',
    benefitVettedTitle: 'Geprüfte Entsorgungsbetriebe',
    benefitVettedDesc:
      'Wir vermitteln ausschließlich geprüfte Münchner Entrümpelungsfirmen mit Versicherung und Fachnachweis.',
    benefitFastTitle: 'Schnelle Termine',
    benefitFastDesc:
      'Erhalten Sie Angebote innerhalb von 24 Stunden und buchen Sie Ihren Wunschtermin – auch kurzfristig.',
    servicesTitle: 'Unsere Entrümpelung & Entsorgung-Services in München',
    servicesSubtitle: 'Welche Art von Entrümpelung benötigen Sie in München?',
    serviceApartmentTitle: 'Wohnungsauflösung',
    serviceApartmentDesc:
      'Komplette oder teilweise Auflösung Ihrer Wohnung in München inkl. fachgerechter Entsorgung.',
    serviceSecondaryTitle: 'Haushaltsauflösung',
    serviceSecondaryDesc:
      'Auflösung ganzer Haushalte in München – einfühlsam, diskret und mit Entsorgungsnachweis.',
    serviceThirdTitle: 'Keller- & Dachbodenentrümpelung',
    serviceThirdDesc:
      'Endlich wieder Platz in Keller und Dachboden in München – inkl. Sperrmüll- und Sondermüllabholung.',
    serviceFourthTitle: 'Gartenentrümpelung',
    serviceFourthDesc:
      'Entfernung von Gartenabfällen, alten Möbeln und Bauschutt in München – inkl. Abtransport.',
    processTitle: 'So läuft Ihre Entrümpelung & Entsorgung in München ab',
    processSubtitle: 'In drei einfachen Schritten zu Ihrer passenden Entrümpelungsfirma in München',
    step1Title: 'Anfrage stellen',
    step1Desc: 'Beschreiben Sie Ihr Anliegen in München in wenigen Schritten online.',
    step2Title: 'Münchner Firmen erhalten',
    step2Desc: 'Passende Entrümpelungsfirmen aus München senden Ihnen ihre Angebote.',
    step3Title: 'Firma wählen',
    step3Desc: 'Vergleichen Sie Bewertungen und wählen Sie das beste Angebot in München.',
    statsTitle: 'Entrümpelung & Entsorgung in München in Zahlen',
    statsSubtitle: 'Vertrauen der Münchner Kund:innen auf RegionalUmzug24',
    statFirms: '110+',
    statFirmsLabel: 'Münchner Entrümpelungsfirmen',
    statJobs: '230+',
    statJobsLabel: 'Vermittelte Aufträge',
    statRating: '4,7/5',
    statRatingLabel: 'Kundenbewertung',
    trustTitle: 'Geprüfte Münchner Entrümpelungsfirmen',
    trustSubtitle: 'Sicherheit und Qualität – speziell für München',
    trustVerifiedTitle: 'Verifizierte Münchner Firmen',
    trustVerifiedDesc:
      'Jede Firma wird auf Gewerbeanmeldung, Versicherung und Entrümpelung-Erfahrung geprüft.',
    trustGdprTitle: 'DSGVO-konform',
    trustGdprDesc: 'Ihre Daten werden verschlüsselt übertragen und nicht an Dritte weitergegeben.',
    trustFreeTitle: '100 % kostenlos',
    trustFreeDesc:
      'Die Nutzung von RegionalUmzug24 ist für Sie komplett kostenfrei – ohne versteckte Gebühren.',
    faqTitle: 'Häufige Fragen zur Entrümpelung & Entsorgung in München',
    faqSubtitle:
      'Antworten auf die wichtigsten Fragen rund um Entrümpelung & Entsorgung in München',
    faq1Question: 'Was kostet eine Entrümpelung in München?',
    faq1Answer:
      'Die Kosten hängen von Volumen, Stockwerk und Entsorgungsart ab. Über uns erhalten Sie kostenlos vergleichbare Angebote aus München.',
    faq2Question: 'Werden die Sachen in München fachgerecht entsorgt?',
    faq2Answer:
      'Ja, alle vermittelten {cityAdj} Firmen entsorgen fachgerecht mit Nachweis. Wertstoffe werden recycelt, Restmüll ordnungsgemäß entsorgt.',
    faq3Question: 'Wie schnell geht eine Entrümpelung in München?',
    faq3Answer:
      'In der Regel erhalten Sie innerhalb von 24 Stunden die ersten Angebote. Viele {cityAdj} Firmen bieten Termine innerhalb weniger Tage an.',
    faq4Question: 'Kann ich auch nur einzelne Räume in München entrümpeln lassen?',
    faq4Answer:
      'Ja, Sie können die Anfrage auf einzelne Räume, Keller oder Dachboden in München beschränken – die Firmen erstellen ein passendes Angebot.',
    faq5Question: 'Was passiert mit verwertbaren Gegenständen in München?',
    faq5Answer:
      'Wertvolle oder verwertbare Gegenstände können vorab aussortiert werden. Klären Sie Details direkt mit der gewählten {cityAdj} Firma.',
    ctaTitle: 'Bereit für Ihre Entrümpelung & Entsorgung in München?',
    ctaSubtitle:
      'Erstellen Sie jetzt kostenlos Ihre Anfrage und erhalten Sie Angebote von geprüften Münchner Entrümpelungsfirmen.',
    ctaPrimary: 'Jetzt Anfrage erstellen',
    ctaSecondary: 'Münchner Firmen ansehen',
  },
  disposalMunchenDirectory: {
    metaTitle: 'Entrümpelungsfirmen München | RegionalUmzug24 – Münchner Firmen vergleichen',
    metaDescription:
      'Liste geprüfter Entrümpelungsfirmen in München. Vergleichen Sie Bewertungen, Spezialgebiete und Preise von münchner Entrümpelungsfirmen im PLZ-Bereich 80-81.',
    metaKeywords:
      'Entrümpelungsfirmen München, münchner Entrümpelungsfirma, Entrümpelungs München Firmen',
    pageTitle: 'Entrümpelungsfirmen in München',
    pageSubtitle:
      'Entdecken Sie geprüfte münchner Entrümpelungsfirmen mit echten Bewertungen. PLZ-Bereich 80-81 – abgestimmt auf München.',
    filterTitle: 'Filter',
    filterPremium: 'Nur Premium-Firmen',
    filterVerified: 'Nur verifizierte Firmen',
    filterPostalTitle: 'PLZ-Bereich',
    filterPostalAll: 'Alle PLZ-Bereiche',
    sortTitle: 'Sortierung',
    sortRating: 'Beste Bewertung',
    sortOrders: 'Meiste Aufträge',
    sortNewest: 'Neueste',
    resultCount: '{{count}} Firmen gefunden',
    emptyTitle: 'Keine Firmen gefunden',
    emptyDescription:
      'Mit den aktuellen Filtern wurden keine münchner Entrümpelungsfirmen gefunden. Versuchen Sie, die Filter anzupassen.',
    emptyReset: 'Filter zurücksetzen',
    loadingTitle: 'Lade münchner Entrümpelungsfirmen...',
    errorTitle: 'Fehler beim Laden',
    errorDescription:
      'Die Liste der münchner Entrümpelungsfirmen konnte nicht geladen werden. Bitte versuchen Sie es erneut.',
    errorRetry: 'Erneut versuchen',
    paginationPrev: 'Zurück',
    paginationNext: 'Weiter',
    paginationPage: 'Seite {{page}} von {{total}}',
    filterPostal80: 'PLZ 80 (Innenstadt)',
    filterPostal81: 'PLZ 81 (Umland)',
  },
  cleaningKolnLanding: {
    metaTitle: 'Reinigung Köln | RegionalUmzug24 – Reinigungsfirmen vergleichen',
    metaDescription:
      'Finden Sie geprüfte Reinigungsfirmen in Köln. Kostenlos Angebote von verifizierten Kölner Reinigungsfirmen vergleichen – Erfahrung mit Dom, Südstadt und Rheinauhafen.',
    metaKeywords: 'Reinigung Köln, Reinigungsfirma Köln, Reinigungskosten Köln',
    heroTitleStart: 'Ihre Reinigung in',
    heroTitleHighlight: 'Köln.',
    heroSubtitle:
      'Vergleichen Sie kostenlos geprüfte Kölner Reinigungsfirmen – schnell, diskret und mit Erfahrung für Dom, Südstadt und Rheinauhafen.',
    heroCtaPrimary: 'Jetzt Angebote erhalten',
    heroCtaSecondary: 'Kölner Firmen ansehen',
    heroStatFirms: '140+ Kölner Firmen',
    heroStatMoves: '280+ vermittelte Aufträge',
    heroStatRating: '4,8/5 Bewertung',
    benefitsTitle: 'Ihre Vorteile mit RegionalUmzug24 für Reinigung in Köln',
    benefitsSubtitle: 'Warum sich Kölner Kund:innen für unsere Vermittlungsplattform entscheiden',
    benefitFreeTitle: '100 % kostenlos',
    benefitFreeDesc: 'Anfrage und Vergleich sind für Sie komplett kostenfrei und unverbindlich.',
    benefitVettedTitle: 'Geprüfte Reinigungskräfte',
    benefitVettedDesc:
      'Wir vermitteln ausschließlich geprüfte Kölner Reinigungsfirmen mit Versicherung und Fachnachweis.',
    benefitFastTitle: 'Schnelle Termine',
    benefitFastDesc:
      'Erhalten Sie Angebote innerhalb von 24 Stunden und buchen Sie Ihren Wunschtermin – auch kurzfristig.',
    servicesTitle: 'Unsere Reinigung-Services in Köln',
    servicesSubtitle: 'Welche Art von Reinigung benötigen Sie in Köln?',
    serviceApartmentTitle: 'Wohnungsreinigung',
    serviceApartmentDesc:
      'Gründliche Reinigung Ihrer Wohnung – perfekt vor oder nach einem Umzug in Köln.',
    serviceSecondaryTitle: 'Büroreinigung',
    serviceSecondaryDesc:
      'Regelmäßige oder einmalige professionelle Reinigung Ihres Büros oder Ihrer Praxis in Köln.',
    serviceThirdTitle: 'Endreinigung',
    serviceThirdDesc:
      'Besenreine Übergabe Ihrer Wohnung in Köln inkl. Abnahmegarantie mit dem Vermieter.',
    serviceFourthTitle: 'Fensterreinigung',
    serviceFourthDesc:
      'Streifenfreie Fenster, Rahmen und Fensterbänke in Köln – auch in schwer zugänglichen Höhen.',
    processTitle: 'So läuft Ihre Reinigung in Köln ab',
    processSubtitle: 'In drei einfachen Schritten zu Ihrer passenden Reinigungsfirma in Köln',
    step1Title: 'Anfrage stellen',
    step1Desc: 'Beschreiben Sie Ihr Anliegen in Köln in wenigen Schritten online.',
    step2Title: 'Kölner Firmen erhalten',
    step2Desc: 'Passende Reinigungsfirmen aus Köln senden Ihnen ihre Angebote.',
    step3Title: 'Firma wählen',
    step3Desc: 'Vergleichen Sie Bewertungen und wählen Sie das beste Angebot in Köln.',
    statsTitle: 'Reinigung in Köln in Zahlen',
    statsSubtitle: 'Vertrauen der Kölner Kund:innen auf RegionalUmzug24',
    statFirms: '140+',
    statFirmsLabel: 'Kölner Reinigungsfirmen',
    statJobs: '280+',
    statJobsLabel: 'Vermittelte Aufträge',
    statRating: '4,8/5',
    statRatingLabel: 'Kundenbewertung',
    trustTitle: 'Geprüfte Kölner Reinigungsfirmen',
    trustSubtitle: 'Sicherheit und Qualität – speziell für Köln',
    trustVerifiedTitle: 'Verifizierte Kölner Firmen',
    trustVerifiedDesc:
      'Jede Firma wird auf Gewerbeanmeldung, Versicherung und Reinigung-Erfahrung geprüft.',
    trustGdprTitle: 'DSGVO-konform',
    trustGdprDesc: 'Ihre Daten werden verschlüsselt übertragen und nicht an Dritte weitergegeben.',
    trustFreeTitle: '100 % kostenlos',
    trustFreeDesc:
      'Die Nutzung von RegionalUmzug24 ist für Sie komplett kostenfrei – ohne versteckte Gebühren.',
    faqTitle: 'Häufige Fragen zur Reinigung in Köln',
    faqSubtitle: 'Antworten auf die wichtigsten Fragen rund um Reinigung in Köln',
    faq1Question: 'Was kostet eine Reinigung in Köln?',
    faq1Answer:
      'Die Kosten hängen von Größe, Zustand und Art der Reinigung ab. Über uns erhalten Sie kostenlos vergleichbare Angebote aus Köln.',
    faq2Question: 'Sind die Reinigungsfirmen in Köln versichert?',
    faq2Answer:
      'Ja, alle vermittelten {cityAdj} Reinigungsfirmen sind geprüft und haftpflichtversichert. So sind Sie bei eventuellen Schäden abgesichert.',
    faq3Question: 'Wie schnell bekomme ich Angebote aus Köln?',
    faq3Answer:
      'In der Regel erhalten Sie innerhalb von 24 Stunden die ersten Angebote von passenden Reinigungsfirmen in Köln und Umgebung.',
    faq4Question: 'Kann ich kurzfristig eine Reinigung in Köln buchen?',
    faq4Answer:
      'Ja, viele Reinigungsfirmen in Köln bieten auch kurzfristige Termine an. Geben Sie Ihren Wunschtermin einfach in der Anfrage an.',
    faq5Question: 'Welche Reinigungsleistungen werden in Köln angeboten?',
    faq5Answer:
      'Von der Wohnungsreinigung über die Büroreinigung bis zur Fenster- und Teppichreinigung – die vermittelten Firmen decken das gesamte Spektrum ab.',
    ctaTitle: 'Bereit für Ihre Reinigung in Köln?',
    ctaSubtitle:
      'Erstellen Sie jetzt kostenlos Ihre Anfrage und erhalten Sie Angebote von geprüften Kölner Reinigungsfirmen.',
    ctaPrimary: 'Jetzt Anfrage erstellen',
    ctaSecondary: 'Kölner Firmen ansehen',
  },
  cleaningKolnDirectory: {
    metaTitle: 'Reinigungsfirmen Köln | RegionalUmzug24 – Kölner Firmen vergleichen',
    metaDescription:
      'Liste geprüfter Reinigungsfirmen in Köln. Vergleichen Sie Bewertungen, Spezialgebiete und Preise von kölner Reinigungsfirmen im PLZ-Bereich 50-51.',
    metaKeywords: 'Reinigungsfirmen Köln, kölner Reinigungsfirma, Reinigungs Köln Firmen',
    pageTitle: 'Reinigungsfirmen in Köln',
    pageSubtitle:
      'Entdecken Sie geprüfte kölner Reinigungsfirmen mit echten Bewertungen. PLZ-Bereich 50-51 – abgestimmt auf Köln.',
    filterTitle: 'Filter',
    filterPremium: 'Nur Premium-Firmen',
    filterVerified: 'Nur verifizierte Firmen',
    filterPostalTitle: 'PLZ-Bereich',
    filterPostalAll: 'Alle PLZ-Bereiche',
    sortTitle: 'Sortierung',
    sortRating: 'Beste Bewertung',
    sortOrders: 'Meiste Aufträge',
    sortNewest: 'Neueste',
    resultCount: '{{count}} Firmen gefunden',
    emptyTitle: 'Keine Firmen gefunden',
    emptyDescription:
      'Mit den aktuellen Filtern wurden keine kölner Reinigungsfirmen gefunden. Versuchen Sie, die Filter anzupassen.',
    emptyReset: 'Filter zurücksetzen',
    loadingTitle: 'Lade kölner Reinigungsfirmen...',
    errorTitle: 'Fehler beim Laden',
    errorDescription:
      'Die Liste der kölner Reinigungsfirmen konnte nicht geladen werden. Bitte versuchen Sie es erneut.',
    errorRetry: 'Erneut versuchen',
    paginationPrev: 'Zurück',
    paginationNext: 'Weiter',
    paginationPage: 'Seite {{page}} von {{total}}',
    filterPostal50: 'PLZ 50 (Innenstadt)',
    filterPostal51: 'PLZ 51 (rechtsrheinisch)',
  },
  disposalKolnLanding: {
    metaTitle: 'Entrümpelung & Entsorgung Köln | RegionalUmzug24 – Entrümpelungsfirmen vergleichen',
    metaDescription:
      'Finden Sie geprüfte Entrümpelungsfirmen in Köln. Kostenlos Angebote von verifizierten Kölner Entrümpelungsfirmen vergleichen – Erfahrung mit Dom, Südstadt und Rheinauhafen.',
    metaKeywords:
      'Entrümpelung & Entsorgung Köln, Entrümpelungsfirma Köln, Entrümpelungskosten Köln',
    heroTitleStart: 'Ihre Entrümpelung & Entsorgung in',
    heroTitleHighlight: 'Köln.',
    heroSubtitle:
      'Vergleichen Sie kostenlos geprüfte Kölner Entrümpelungsfirmen – schnell, diskret und mit Erfahrung für Dom, Südstadt und Rheinauhafen.',
    heroCtaPrimary: 'Jetzt Angebote erhalten',
    heroCtaSecondary: 'Kölner Firmen ansehen',
    heroStatFirms: '110+ Kölner Firmen',
    heroStatMoves: '230+ vermittelte Aufträge',
    heroStatRating: '4,7/5 Bewertung',
    benefitsTitle: 'Ihre Vorteile mit RegionalUmzug24 für Entrümpelung & Entsorgung in Köln',
    benefitsSubtitle: 'Warum sich Kölner Kund:innen für unsere Vermittlungsplattform entscheiden',
    benefitFreeTitle: '100 % kostenlos',
    benefitFreeDesc: 'Anfrage und Vergleich sind für Sie komplett kostenfrei und unverbindlich.',
    benefitVettedTitle: 'Geprüfte Entsorgungsbetriebe',
    benefitVettedDesc:
      'Wir vermitteln ausschließlich geprüfte Kölner Entrümpelungsfirmen mit Versicherung und Fachnachweis.',
    benefitFastTitle: 'Schnelle Termine',
    benefitFastDesc:
      'Erhalten Sie Angebote innerhalb von 24 Stunden und buchen Sie Ihren Wunschtermin – auch kurzfristig.',
    servicesTitle: 'Unsere Entrümpelung & Entsorgung-Services in Köln',
    servicesSubtitle: 'Welche Art von Entrümpelung benötigen Sie in Köln?',
    serviceApartmentTitle: 'Wohnungsauflösung',
    serviceApartmentDesc:
      'Komplette oder teilweise Auflösung Ihrer Wohnung in Köln inkl. fachgerechter Entsorgung.',
    serviceSecondaryTitle: 'Haushaltsauflösung',
    serviceSecondaryDesc:
      'Auflösung ganzer Haushalte in Köln – einfühlsam, diskret und mit Entsorgungsnachweis.',
    serviceThirdTitle: 'Keller- & Dachbodenentrümpelung',
    serviceThirdDesc:
      'Endlich wieder Platz in Keller und Dachboden in Köln – inkl. Sperrmüll- und Sondermüllabholung.',
    serviceFourthTitle: 'Gartenentrümpelung',
    serviceFourthDesc:
      'Entfernung von Gartenabfällen, alten Möbeln und Bauschutt in Köln – inkl. Abtransport.',
    processTitle: 'So läuft Ihre Entrümpelung & Entsorgung in Köln ab',
    processSubtitle: 'In drei einfachen Schritten zu Ihrer passenden Entrümpelungsfirma in Köln',
    step1Title: 'Anfrage stellen',
    step1Desc: 'Beschreiben Sie Ihr Anliegen in Köln in wenigen Schritten online.',
    step2Title: 'Kölner Firmen erhalten',
    step2Desc: 'Passende Entrümpelungsfirmen aus Köln senden Ihnen ihre Angebote.',
    step3Title: 'Firma wählen',
    step3Desc: 'Vergleichen Sie Bewertungen und wählen Sie das beste Angebot in Köln.',
    statsTitle: 'Entrümpelung & Entsorgung in Köln in Zahlen',
    statsSubtitle: 'Vertrauen der Kölner Kund:innen auf RegionalUmzug24',
    statFirms: '110+',
    statFirmsLabel: 'Kölner Entrümpelungsfirmen',
    statJobs: '230+',
    statJobsLabel: 'Vermittelte Aufträge',
    statRating: '4,7/5',
    statRatingLabel: 'Kundenbewertung',
    trustTitle: 'Geprüfte Kölner Entrümpelungsfirmen',
    trustSubtitle: 'Sicherheit und Qualität – speziell für Köln',
    trustVerifiedTitle: 'Verifizierte Kölner Firmen',
    trustVerifiedDesc:
      'Jede Firma wird auf Gewerbeanmeldung, Versicherung und Entrümpelung-Erfahrung geprüft.',
    trustGdprTitle: 'DSGVO-konform',
    trustGdprDesc: 'Ihre Daten werden verschlüsselt übertragen und nicht an Dritte weitergegeben.',
    trustFreeTitle: '100 % kostenlos',
    trustFreeDesc:
      'Die Nutzung von RegionalUmzug24 ist für Sie komplett kostenfrei – ohne versteckte Gebühren.',
    faqTitle: 'Häufige Fragen zur Entrümpelung & Entsorgung in Köln',
    faqSubtitle: 'Antworten auf die wichtigsten Fragen rund um Entrümpelung & Entsorgung in Köln',
    faq1Question: 'Was kostet eine Entrümpelung in Köln?',
    faq1Answer:
      'Die Kosten hängen von Volumen, Stockwerk und Entsorgungsart ab. Über uns erhalten Sie kostenlos vergleichbare Angebote aus Köln.',
    faq2Question: 'Werden die Sachen in Köln fachgerecht entsorgt?',
    faq2Answer:
      'Ja, alle vermittelten {cityAdj} Firmen entsorgen fachgerecht mit Nachweis. Wertstoffe werden recycelt, Restmüll ordnungsgemäß entsorgt.',
    faq3Question: 'Wie schnell geht eine Entrümpelung in Köln?',
    faq3Answer:
      'In der Regel erhalten Sie innerhalb von 24 Stunden die ersten Angebote. Viele {cityAdj} Firmen bieten Termine innerhalb weniger Tage an.',
    faq4Question: 'Kann ich auch nur einzelne Räume in Köln entrümpeln lassen?',
    faq4Answer:
      'Ja, Sie können die Anfrage auf einzelne Räume, Keller oder Dachboden in Köln beschränken – die Firmen erstellen ein passendes Angebot.',
    faq5Question: 'Was passiert mit verwertbaren Gegenständen in Köln?',
    faq5Answer:
      'Wertvolle oder verwertbare Gegenstände können vorab aussortiert werden. Klären Sie Details direkt mit der gewählten {cityAdj} Firma.',
    ctaTitle: 'Bereit für Ihre Entrümpelung & Entsorgung in Köln?',
    ctaSubtitle:
      'Erstellen Sie jetzt kostenlos Ihre Anfrage und erhalten Sie Angebote von geprüften Kölner Entrümpelungsfirmen.',
    ctaPrimary: 'Jetzt Anfrage erstellen',
    ctaSecondary: 'Kölner Firmen ansehen',
  },
  disposalKolnDirectory: {
    metaTitle: 'Entrümpelungsfirmen Köln | RegionalUmzug24 – Kölner Firmen vergleichen',
    metaDescription:
      'Liste geprüfter Entrümpelungsfirmen in Köln. Vergleichen Sie Bewertungen, Spezialgebiete und Preise von kölner Entrümpelungsfirmen im PLZ-Bereich 50-51.',
    metaKeywords: 'Entrümpelungsfirmen Köln, kölner Entrümpelungsfirma, Entrümpelungs Köln Firmen',
    pageTitle: 'Entrümpelungsfirmen in Köln',
    pageSubtitle:
      'Entdecken Sie geprüfte kölner Entrümpelungsfirmen mit echten Bewertungen. PLZ-Bereich 50-51 – abgestimmt auf Köln.',
    filterTitle: 'Filter',
    filterPremium: 'Nur Premium-Firmen',
    filterVerified: 'Nur verifizierte Firmen',
    filterPostalTitle: 'PLZ-Bereich',
    filterPostalAll: 'Alle PLZ-Bereiche',
    sortTitle: 'Sortierung',
    sortRating: 'Beste Bewertung',
    sortOrders: 'Meiste Aufträge',
    sortNewest: 'Neueste',
    resultCount: '{{count}} Firmen gefunden',
    emptyTitle: 'Keine Firmen gefunden',
    emptyDescription:
      'Mit den aktuellen Filtern wurden keine kölner Entrümpelungsfirmen gefunden. Versuchen Sie, die Filter anzupassen.',
    emptyReset: 'Filter zurücksetzen',
    loadingTitle: 'Lade kölner Entrümpelungsfirmen...',
    errorTitle: 'Fehler beim Laden',
    errorDescription:
      'Die Liste der kölner Entrümpelungsfirmen konnte nicht geladen werden. Bitte versuchen Sie es erneut.',
    errorRetry: 'Erneut versuchen',
    paginationPrev: 'Zurück',
    paginationNext: 'Weiter',
    paginationPage: 'Seite {{page}} von {{total}}',
    filterPostal50: 'PLZ 50 (Innenstadt)',
    filterPostal51: 'PLZ 51 (rechtsrheinisch)',
  },
  cleaningFrankfurtamMainLanding: {
    metaTitle: 'Reinigung Frankfurt am Main | RegionalUmzug24 – Reinigungsfirmen vergleichen',
    metaDescription:
      'Finden Sie geprüfte Reinigungsfirmen in Frankfurt am Main. Kostenlos Angebote von verifizierten Frankfurter Reinigungsfirmen vergleichen – Erfahrung mit Westend, Bankenviertel und Sachsenhausen.',
    metaKeywords:
      'Reinigung Frankfurt am Main, Reinigungsfirma Frankfurt am Main, Reinigungskosten Frankfurt am Main',
    heroTitleStart: 'Ihre Reinigung in',
    heroTitleHighlight: 'Frankfurt am Main.',
    heroSubtitle:
      'Vergleichen Sie kostenlos geprüfte Frankfurter Reinigungsfirmen – schnell, diskret und mit Erfahrung für Westend, Bankenviertel und Sachsenhausen.',
    heroCtaPrimary: 'Jetzt Angebote erhalten',
    heroCtaSecondary: 'Frankfurter Firmen ansehen',
    heroStatFirms: '140+ Frankfurter Firmen',
    heroStatMoves: '280+ vermittelte Aufträge',
    heroStatRating: '4,8/5 Bewertung',
    benefitsTitle: 'Ihre Vorteile mit RegionalUmzug24 für Reinigung in Frankfurt am Main',
    benefitsSubtitle:
      'Warum sich Frankfurter Kund:innen für unsere Vermittlungsplattform entscheiden',
    benefitFreeTitle: '100 % kostenlos',
    benefitFreeDesc: 'Anfrage und Vergleich sind für Sie komplett kostenfrei und unverbindlich.',
    benefitVettedTitle: 'Geprüfte Reinigungskräfte',
    benefitVettedDesc:
      'Wir vermitteln ausschließlich geprüfte Frankfurter Reinigungsfirmen mit Versicherung und Fachnachweis.',
    benefitFastTitle: 'Schnelle Termine',
    benefitFastDesc:
      'Erhalten Sie Angebote innerhalb von 24 Stunden und buchen Sie Ihren Wunschtermin – auch kurzfristig.',
    servicesTitle: 'Unsere Reinigung-Services in Frankfurt am Main',
    servicesSubtitle: 'Welche Art von Reinigung benötigen Sie in Frankfurt am Main?',
    serviceApartmentTitle: 'Wohnungsreinigung',
    serviceApartmentDesc:
      'Gründliche Reinigung Ihrer Wohnung – perfekt vor oder nach einem Umzug in Frankfurt am Main.',
    serviceSecondaryTitle: 'Büroreinigung',
    serviceSecondaryDesc:
      'Regelmäßige oder einmalige professionelle Reinigung Ihres Büros oder Ihrer Praxis in Frankfurt am Main.',
    serviceThirdTitle: 'Endreinigung',
    serviceThirdDesc:
      'Besenreine Übergabe Ihrer Wohnung in Frankfurt am Main inkl. Abnahmegarantie mit dem Vermieter.',
    serviceFourthTitle: 'Fensterreinigung',
    serviceFourthDesc:
      'Streifenfreie Fenster, Rahmen und Fensterbänke in Frankfurt am Main – auch in schwer zugänglichen Höhen.',
    processTitle: 'So läuft Ihre Reinigung in Frankfurt am Main ab',
    processSubtitle:
      'In drei einfachen Schritten zu Ihrer passenden Reinigungsfirma in Frankfurt am Main',
    step1Title: 'Anfrage stellen',
    step1Desc: 'Beschreiben Sie Ihr Anliegen in Frankfurt am Main in wenigen Schritten online.',
    step2Title: 'Frankfurter Firmen erhalten',
    step2Desc: 'Passende Reinigungsfirmen aus Frankfurt am Main senden Ihnen ihre Angebote.',
    step3Title: 'Firma wählen',
    step3Desc: 'Vergleichen Sie Bewertungen und wählen Sie das beste Angebot in Frankfurt am Main.',
    statsTitle: 'Reinigung in Frankfurt am Main in Zahlen',
    statsSubtitle: 'Vertrauen der Frankfurter Kund:innen auf RegionalUmzug24',
    statFirms: '140+',
    statFirmsLabel: 'Frankfurter Reinigungsfirmen',
    statJobs: '280+',
    statJobsLabel: 'Vermittelte Aufträge',
    statRating: '4,8/5',
    statRatingLabel: 'Kundenbewertung',
    trustTitle: 'Geprüfte Frankfurter Reinigungsfirmen',
    trustSubtitle: 'Sicherheit und Qualität – speziell für Frankfurt am Main',
    trustVerifiedTitle: 'Verifizierte Frankfurter Firmen',
    trustVerifiedDesc:
      'Jede Firma wird auf Gewerbeanmeldung, Versicherung und Reinigung-Erfahrung geprüft.',
    trustGdprTitle: 'DSGVO-konform',
    trustGdprDesc: 'Ihre Daten werden verschlüsselt übertragen und nicht an Dritte weitergegeben.',
    trustFreeTitle: '100 % kostenlos',
    trustFreeDesc:
      'Die Nutzung von RegionalUmzug24 ist für Sie komplett kostenfrei – ohne versteckte Gebühren.',
    faqTitle: 'Häufige Fragen zur Reinigung in Frankfurt am Main',
    faqSubtitle: 'Antworten auf die wichtigsten Fragen rund um Reinigung in Frankfurt am Main',
    faq1Question: 'Was kostet eine Reinigung in Frankfurt am Main?',
    faq1Answer:
      'Die Kosten hängen von Größe, Zustand und Art der Reinigung ab. Über uns erhalten Sie kostenlos vergleichbare Angebote aus Frankfurt am Main.',
    faq2Question: 'Sind die Reinigungsfirmen in Frankfurt am Main versichert?',
    faq2Answer:
      'Ja, alle vermittelten {cityAdj} Reinigungsfirmen sind geprüft und haftpflichtversichert. So sind Sie bei eventuellen Schäden abgesichert.',
    faq3Question: 'Wie schnell bekomme ich Angebote aus Frankfurt am Main?',
    faq3Answer:
      'In der Regel erhalten Sie innerhalb von 24 Stunden die ersten Angebote von passenden Reinigungsfirmen in Frankfurt am Main und Umgebung.',
    faq4Question: 'Kann ich kurzfristig eine Reinigung in Frankfurt am Main buchen?',
    faq4Answer:
      'Ja, viele Reinigungsfirmen in Frankfurt am Main bieten auch kurzfristige Termine an. Geben Sie Ihren Wunschtermin einfach in der Anfrage an.',
    faq5Question: 'Welche Reinigungsleistungen werden in Frankfurt am Main angeboten?',
    faq5Answer:
      'Von der Wohnungsreinigung über die Büroreinigung bis zur Fenster- und Teppichreinigung – die vermittelten Firmen decken das gesamte Spektrum ab.',
    ctaTitle: 'Bereit für Ihre Reinigung in Frankfurt am Main?',
    ctaSubtitle:
      'Erstellen Sie jetzt kostenlos Ihre Anfrage und erhalten Sie Angebote von geprüften Frankfurter Reinigungsfirmen.',
    ctaPrimary: 'Jetzt Anfrage erstellen',
    ctaSecondary: 'Frankfurter Firmen ansehen',
  },
  cleaningFrankfurtamMainDirectory: {
    metaTitle:
      'Reinigungsfirmen Frankfurt am Main | RegionalUmzug24 – Frankfurter Firmen vergleichen',
    metaDescription:
      'Liste geprüfter Reinigungsfirmen in Frankfurt am Main. Vergleichen Sie Bewertungen, Spezialgebiete und Preise von frankfurter Reinigungsfirmen im PLZ-Bereich 60-65.',
    metaKeywords:
      'Reinigungsfirmen Frankfurt am Main, frankfurter Reinigungsfirma, Reinigungs Frankfurt am Main Firmen',
    pageTitle: 'Reinigungsfirmen in Frankfurt am Main',
    pageSubtitle:
      'Entdecken Sie geprüfte frankfurter Reinigungsfirmen mit echten Bewertungen. PLZ-Bereich 60-65 – abgestimmt auf Frankfurt am Main.',
    filterTitle: 'Filter',
    filterPremium: 'Nur Premium-Firmen',
    filterVerified: 'Nur verifizierte Firmen',
    filterPostalTitle: 'PLZ-Bereich',
    filterPostalAll: 'Alle PLZ-Bereiche',
    sortTitle: 'Sortierung',
    sortRating: 'Beste Bewertung',
    sortOrders: 'Meiste Aufträge',
    sortNewest: 'Neueste',
    resultCount: '{{count}} Firmen gefunden',
    emptyTitle: 'Keine Firmen gefunden',
    emptyDescription:
      'Mit den aktuellen Filtern wurden keine frankfurter Reinigungsfirmen gefunden. Versuchen Sie, die Filter anzupassen.',
    emptyReset: 'Filter zurücksetzen',
    loadingTitle: 'Lade frankfurter Reinigungsfirmen...',
    errorTitle: 'Fehler beim Laden',
    errorDescription:
      'Die Liste der frankfurter Reinigungsfirmen konnte nicht geladen werden. Bitte versuchen Sie es erneut.',
    errorRetry: 'Erneut versuchen',
    paginationPrev: 'Zurück',
    paginationNext: 'Weiter',
    paginationPage: 'Seite {{page}} von {{total}}',
    filterPostal60: 'PLZ 60 (Westend)',
    filterPostal65: 'PLZ 65 (Höchst)',
  },
  disposalFrankfurtamMainLanding: {
    metaTitle:
      'Entrümpelung & Entsorgung Frankfurt am Main | RegionalUmzug24 – Entrümpelungsfirmen vergleichen',
    metaDescription:
      'Finden Sie geprüfte Entrümpelungsfirmen in Frankfurt am Main. Kostenlos Angebote von verifizierten Frankfurter Entrümpelungsfirmen vergleichen – Erfahrung mit Westend, Bankenviertel und Sachsenhausen.',
    metaKeywords:
      'Entrümpelung & Entsorgung Frankfurt am Main, Entrümpelungsfirma Frankfurt am Main, Entrümpelungskosten Frankfurt am Main',
    heroTitleStart: 'Ihre Entrümpelung & Entsorgung in',
    heroTitleHighlight: 'Frankfurt am Main.',
    heroSubtitle:
      'Vergleichen Sie kostenlos geprüfte Frankfurter Entrümpelungsfirmen – schnell, diskret und mit Erfahrung für Westend, Bankenviertel und Sachsenhausen.',
    heroCtaPrimary: 'Jetzt Angebote erhalten',
    heroCtaSecondary: 'Frankfurter Firmen ansehen',
    heroStatFirms: '110+ Frankfurter Firmen',
    heroStatMoves: '230+ vermittelte Aufträge',
    heroStatRating: '4,7/5 Bewertung',
    benefitsTitle:
      'Ihre Vorteile mit RegionalUmzug24 für Entrümpelung & Entsorgung in Frankfurt am Main',
    benefitsSubtitle:
      'Warum sich Frankfurter Kund:innen für unsere Vermittlungsplattform entscheiden',
    benefitFreeTitle: '100 % kostenlos',
    benefitFreeDesc: 'Anfrage und Vergleich sind für Sie komplett kostenfrei und unverbindlich.',
    benefitVettedTitle: 'Geprüfte Entsorgungsbetriebe',
    benefitVettedDesc:
      'Wir vermitteln ausschließlich geprüfte Frankfurter Entrümpelungsfirmen mit Versicherung und Fachnachweis.',
    benefitFastTitle: 'Schnelle Termine',
    benefitFastDesc:
      'Erhalten Sie Angebote innerhalb von 24 Stunden und buchen Sie Ihren Wunschtermin – auch kurzfristig.',
    servicesTitle: 'Unsere Entrümpelung & Entsorgung-Services in Frankfurt am Main',
    servicesSubtitle: 'Welche Art von Entrümpelung benötigen Sie in Frankfurt am Main?',
    serviceApartmentTitle: 'Wohnungsauflösung',
    serviceApartmentDesc:
      'Komplette oder teilweise Auflösung Ihrer Wohnung in Frankfurt am Main inkl. fachgerechter Entsorgung.',
    serviceSecondaryTitle: 'Haushaltsauflösung',
    serviceSecondaryDesc:
      'Auflösung ganzer Haushalte in Frankfurt am Main – einfühlsam, diskret und mit Entsorgungsnachweis.',
    serviceThirdTitle: 'Keller- & Dachbodenentrümpelung',
    serviceThirdDesc:
      'Endlich wieder Platz in Keller und Dachboden in Frankfurt am Main – inkl. Sperrmüll- und Sondermüllabholung.',
    serviceFourthTitle: 'Gartenentrümpelung',
    serviceFourthDesc:
      'Entfernung von Gartenabfällen, alten Möbeln und Bauschutt in Frankfurt am Main – inkl. Abtransport.',
    processTitle: 'So läuft Ihre Entrümpelung & Entsorgung in Frankfurt am Main ab',
    processSubtitle:
      'In drei einfachen Schritten zu Ihrer passenden Entrümpelungsfirma in Frankfurt am Main',
    step1Title: 'Anfrage stellen',
    step1Desc: 'Beschreiben Sie Ihr Anliegen in Frankfurt am Main in wenigen Schritten online.',
    step2Title: 'Frankfurter Firmen erhalten',
    step2Desc: 'Passende Entrümpelungsfirmen aus Frankfurt am Main senden Ihnen ihre Angebote.',
    step3Title: 'Firma wählen',
    step3Desc: 'Vergleichen Sie Bewertungen und wählen Sie das beste Angebot in Frankfurt am Main.',
    statsTitle: 'Entrümpelung & Entsorgung in Frankfurt am Main in Zahlen',
    statsSubtitle: 'Vertrauen der Frankfurter Kund:innen auf RegionalUmzug24',
    statFirms: '110+',
    statFirmsLabel: 'Frankfurter Entrümpelungsfirmen',
    statJobs: '230+',
    statJobsLabel: 'Vermittelte Aufträge',
    statRating: '4,7/5',
    statRatingLabel: 'Kundenbewertung',
    trustTitle: 'Geprüfte Frankfurter Entrümpelungsfirmen',
    trustSubtitle: 'Sicherheit und Qualität – speziell für Frankfurt am Main',
    trustVerifiedTitle: 'Verifizierte Frankfurter Firmen',
    trustVerifiedDesc:
      'Jede Firma wird auf Gewerbeanmeldung, Versicherung und Entrümpelung-Erfahrung geprüft.',
    trustGdprTitle: 'DSGVO-konform',
    trustGdprDesc: 'Ihre Daten werden verschlüsselt übertragen und nicht an Dritte weitergegeben.',
    trustFreeTitle: '100 % kostenlos',
    trustFreeDesc:
      'Die Nutzung von RegionalUmzug24 ist für Sie komplett kostenfrei – ohne versteckte Gebühren.',
    faqTitle: 'Häufige Fragen zur Entrümpelung & Entsorgung in Frankfurt am Main',
    faqSubtitle:
      'Antworten auf die wichtigsten Fragen rund um Entrümpelung & Entsorgung in Frankfurt am Main',
    faq1Question: 'Was kostet eine Entrümpelung in Frankfurt am Main?',
    faq1Answer:
      'Die Kosten hängen von Volumen, Stockwerk und Entsorgungsart ab. Über uns erhalten Sie kostenlos vergleichbare Angebote aus Frankfurt am Main.',
    faq2Question: 'Werden die Sachen in Frankfurt am Main fachgerecht entsorgt?',
    faq2Answer:
      'Ja, alle vermittelten {cityAdj} Firmen entsorgen fachgerecht mit Nachweis. Wertstoffe werden recycelt, Restmüll ordnungsgemäß entsorgt.',
    faq3Question: 'Wie schnell geht eine Entrümpelung in Frankfurt am Main?',
    faq3Answer:
      'In der Regel erhalten Sie innerhalb von 24 Stunden die ersten Angebote. Viele {cityAdj} Firmen bieten Termine innerhalb weniger Tage an.',
    faq4Question: 'Kann ich auch nur einzelne Räume in Frankfurt am Main entrümpeln lassen?',
    faq4Answer:
      'Ja, Sie können die Anfrage auf einzelne Räume, Keller oder Dachboden in Frankfurt am Main beschränken – die Firmen erstellen ein passendes Angebot.',
    faq5Question: 'Was passiert mit verwertbaren Gegenständen in Frankfurt am Main?',
    faq5Answer:
      'Wertvolle oder verwertbare Gegenstände können vorab aussortiert werden. Klären Sie Details direkt mit der gewählten {cityAdj} Firma.',
    ctaTitle: 'Bereit für Ihre Entrümpelung & Entsorgung in Frankfurt am Main?',
    ctaSubtitle:
      'Erstellen Sie jetzt kostenlos Ihre Anfrage und erhalten Sie Angebote von geprüften Frankfurter Entrümpelungsfirmen.',
    ctaPrimary: 'Jetzt Anfrage erstellen',
    ctaSecondary: 'Frankfurter Firmen ansehen',
  },
  disposalFrankfurtamMainDirectory: {
    metaTitle:
      'Entrümpelungsfirmen Frankfurt am Main | RegionalUmzug24 – Frankfurter Firmen vergleichen',
    metaDescription:
      'Liste geprüfter Entrümpelungsfirmen in Frankfurt am Main. Vergleichen Sie Bewertungen, Spezialgebiete und Preise von frankfurter Entrümpelungsfirmen im PLZ-Bereich 60-65.',
    metaKeywords:
      'Entrümpelungsfirmen Frankfurt am Main, frankfurter Entrümpelungsfirma, Entrümpelungs Frankfurt am Main Firmen',
    pageTitle: 'Entrümpelungsfirmen in Frankfurt am Main',
    pageSubtitle:
      'Entdecken Sie geprüfte frankfurter Entrümpelungsfirmen mit echten Bewertungen. PLZ-Bereich 60-65 – abgestimmt auf Frankfurt am Main.',
    filterTitle: 'Filter',
    filterPremium: 'Nur Premium-Firmen',
    filterVerified: 'Nur verifizierte Firmen',
    filterPostalTitle: 'PLZ-Bereich',
    filterPostalAll: 'Alle PLZ-Bereiche',
    sortTitle: 'Sortierung',
    sortRating: 'Beste Bewertung',
    sortOrders: 'Meiste Aufträge',
    sortNewest: 'Neueste',
    resultCount: '{{count}} Firmen gefunden',
    emptyTitle: 'Keine Firmen gefunden',
    emptyDescription:
      'Mit den aktuellen Filtern wurden keine frankfurter Entrümpelungsfirmen gefunden. Versuchen Sie, die Filter anzupassen.',
    emptyReset: 'Filter zurücksetzen',
    loadingTitle: 'Lade frankfurter Entrümpelungsfirmen...',
    errorTitle: 'Fehler beim Laden',
    errorDescription:
      'Die Liste der frankfurter Entrümpelungsfirmen konnte nicht geladen werden. Bitte versuchen Sie es erneut.',
    errorRetry: 'Erneut versuchen',
    paginationPrev: 'Zurück',
    paginationNext: 'Weiter',
    paginationPage: 'Seite {{page}} von {{total}}',
    filterPostal60: 'PLZ 60 (Westend)',
    filterPostal65: 'PLZ 65 (Höchst)',
  },
  cleaningStuttgartLanding: {
    metaTitle: 'Reinigung Stuttgart | RegionalUmzug24 – Reinigungsfirmen vergleichen',
    metaDescription:
      'Finden Sie geprüfte Reinigungsfirmen in Stuttgart. Kostenlos Angebote von verifizierten Stuttgarter Reinigungsfirmen vergleichen – Erfahrung mit Talkessel, Filder und Schwabenland.',
    metaKeywords: 'Reinigung Stuttgart, Reinigungsfirma Stuttgart, Reinigungskosten Stuttgart',
    heroTitleStart: 'Ihre Reinigung in',
    heroTitleHighlight: 'Stuttgart.',
    heroSubtitle:
      'Vergleichen Sie kostenlos geprüfte Stuttgarter Reinigungsfirmen – schnell, diskret und mit Erfahrung für Talkessel, Filder und Schwabenland.',
    heroCtaPrimary: 'Jetzt Angebote erhalten',
    heroCtaSecondary: 'Stuttgarter Firmen ansehen',
    heroStatFirms: '140+ Stuttgarter Firmen',
    heroStatMoves: '280+ vermittelte Aufträge',
    heroStatRating: '4,8/5 Bewertung',
    benefitsTitle: 'Ihre Vorteile mit RegionalUmzug24 für Reinigung in Stuttgart',
    benefitsSubtitle:
      'Warum sich Stuttgarter Kund:innen für unsere Vermittlungsplattform entscheiden',
    benefitFreeTitle: '100 % kostenlos',
    benefitFreeDesc: 'Anfrage und Vergleich sind für Sie komplett kostenfrei und unverbindlich.',
    benefitVettedTitle: 'Geprüfte Reinigungskräfte',
    benefitVettedDesc:
      'Wir vermitteln ausschließlich geprüfte Stuttgarter Reinigungsfirmen mit Versicherung und Fachnachweis.',
    benefitFastTitle: 'Schnelle Termine',
    benefitFastDesc:
      'Erhalten Sie Angebote innerhalb von 24 Stunden und buchen Sie Ihren Wunschtermin – auch kurzfristig.',
    servicesTitle: 'Unsere Reinigung-Services in Stuttgart',
    servicesSubtitle: 'Welche Art von Reinigung benötigen Sie in Stuttgart?',
    serviceApartmentTitle: 'Wohnungsreinigung',
    serviceApartmentDesc:
      'Gründliche Reinigung Ihrer Wohnung – perfekt vor oder nach einem Umzug in Stuttgart.',
    serviceSecondaryTitle: 'Büroreinigung',
    serviceSecondaryDesc:
      'Regelmäßige oder einmalige professionelle Reinigung Ihres Büros oder Ihrer Praxis in Stuttgart.',
    serviceThirdTitle: 'Endreinigung',
    serviceThirdDesc:
      'Besenreine Übergabe Ihrer Wohnung in Stuttgart inkl. Abnahmegarantie mit dem Vermieter.',
    serviceFourthTitle: 'Fensterreinigung',
    serviceFourthDesc:
      'Streifenfreie Fenster, Rahmen und Fensterbänke in Stuttgart – auch in schwer zugänglichen Höhen.',
    processTitle: 'So läuft Ihre Reinigung in Stuttgart ab',
    processSubtitle: 'In drei einfachen Schritten zu Ihrer passenden Reinigungsfirma in Stuttgart',
    step1Title: 'Anfrage stellen',
    step1Desc: 'Beschreiben Sie Ihr Anliegen in Stuttgart in wenigen Schritten online.',
    step2Title: 'Stuttgarter Firmen erhalten',
    step2Desc: 'Passende Reinigungsfirmen aus Stuttgart senden Ihnen ihre Angebote.',
    step3Title: 'Firma wählen',
    step3Desc: 'Vergleichen Sie Bewertungen und wählen Sie das beste Angebot in Stuttgart.',
    statsTitle: 'Reinigung in Stuttgart in Zahlen',
    statsSubtitle: 'Vertrauen der Stuttgarter Kund:innen auf RegionalUmzug24',
    statFirms: '140+',
    statFirmsLabel: 'Stuttgarter Reinigungsfirmen',
    statJobs: '280+',
    statJobsLabel: 'Vermittelte Aufträge',
    statRating: '4,8/5',
    statRatingLabel: 'Kundenbewertung',
    trustTitle: 'Geprüfte Stuttgarter Reinigungsfirmen',
    trustSubtitle: 'Sicherheit und Qualität – speziell für Stuttgart',
    trustVerifiedTitle: 'Verifizierte Stuttgarter Firmen',
    trustVerifiedDesc:
      'Jede Firma wird auf Gewerbeanmeldung, Versicherung und Reinigung-Erfahrung geprüft.',
    trustGdprTitle: 'DSGVO-konform',
    trustGdprDesc: 'Ihre Daten werden verschlüsselt übertragen und nicht an Dritte weitergegeben.',
    trustFreeTitle: '100 % kostenlos',
    trustFreeDesc:
      'Die Nutzung von RegionalUmzug24 ist für Sie komplett kostenfrei – ohne versteckte Gebühren.',
    faqTitle: 'Häufige Fragen zur Reinigung in Stuttgart',
    faqSubtitle: 'Antworten auf die wichtigsten Fragen rund um Reinigung in Stuttgart',
    faq1Question: 'Was kostet eine Reinigung in Stuttgart?',
    faq1Answer:
      'Die Kosten hängen von Größe, Zustand und Art der Reinigung ab. Über uns erhalten Sie kostenlos vergleichbare Angebote aus Stuttgart.',
    faq2Question: 'Sind die Reinigungsfirmen in Stuttgart versichert?',
    faq2Answer:
      'Ja, alle vermittelten {cityAdj} Reinigungsfirmen sind geprüft und haftpflichtversichert. So sind Sie bei eventuellen Schäden abgesichert.',
    faq3Question: 'Wie schnell bekomme ich Angebote aus Stuttgart?',
    faq3Answer:
      'In der Regel erhalten Sie innerhalb von 24 Stunden die ersten Angebote von passenden Reinigungsfirmen in Stuttgart und Umgebung.',
    faq4Question: 'Kann ich kurzfristig eine Reinigung in Stuttgart buchen?',
    faq4Answer:
      'Ja, viele Reinigungsfirmen in Stuttgart bieten auch kurzfristige Termine an. Geben Sie Ihren Wunschtermin einfach in der Anfrage an.',
    faq5Question: 'Welche Reinigungsleistungen werden in Stuttgart angeboten?',
    faq5Answer:
      'Von der Wohnungsreinigung über die Büroreinigung bis zur Fenster- und Teppichreinigung – die vermittelten Firmen decken das gesamte Spektrum ab.',
    ctaTitle: 'Bereit für Ihre Reinigung in Stuttgart?',
    ctaSubtitle:
      'Erstellen Sie jetzt kostenlos Ihre Anfrage und erhalten Sie Angebote von geprüften Stuttgarter Reinigungsfirmen.',
    ctaPrimary: 'Jetzt Anfrage erstellen',
    ctaSecondary: 'Stuttgarter Firmen ansehen',
  },
  cleaningStuttgartDirectory: {
    metaTitle: 'Reinigungsfirmen Stuttgart | RegionalUmzug24 – Stuttgarter Firmen vergleichen',
    metaDescription:
      'Liste geprüfter Reinigungsfirmen in Stuttgart. Vergleichen Sie Bewertungen, Spezialgebiete und Preise von stuttgarter Reinigungsfirmen im PLZ-Bereich 70.',
    metaKeywords:
      'Reinigungsfirmen Stuttgart, stuttgarter Reinigungsfirma, Reinigungs Stuttgart Firmen',
    pageTitle: 'Reinigungsfirmen in Stuttgart',
    pageSubtitle:
      'Entdecken Sie geprüfte stuttgarter Reinigungsfirmen mit echten Bewertungen. PLZ-Bereich 70 – abgestimmt auf Stuttgart.',
    filterTitle: 'Filter',
    filterPremium: 'Nur Premium-Firmen',
    filterVerified: 'Nur verifizierte Firmen',
    filterPostalTitle: 'PLZ-Bereich',
    filterPostalAll: 'Alle PLZ-Bereiche',
    sortTitle: 'Sortierung',
    sortRating: 'Beste Bewertung',
    sortOrders: 'Meiste Aufträge',
    sortNewest: 'Neueste',
    resultCount: '{{count}} Firmen gefunden',
    emptyTitle: 'Keine Firmen gefunden',
    emptyDescription:
      'Mit den aktuellen Filtern wurden keine stuttgarter Reinigungsfirmen gefunden. Versuchen Sie, die Filter anzupassen.',
    emptyReset: 'Filter zurücksetzen',
    loadingTitle: 'Lade stuttgarter Reinigungsfirmen...',
    errorTitle: 'Fehler beim Laden',
    errorDescription:
      'Die Liste der stuttgarter Reinigungsfirmen konnte nicht geladen werden. Bitte versuchen Sie es erneut.',
    errorRetry: 'Erneut versuchen',
    paginationPrev: 'Zurück',
    paginationNext: 'Weiter',
    paginationPage: 'Seite {{page}} von {{total}}',
    filterPostal70: 'PLZ 70 (Talkessel)',
  },
  disposalStuttgartLanding: {
    metaTitle:
      'Entrümpelung & Entsorgung Stuttgart | RegionalUmzug24 – Entrümpelungsfirmen vergleichen',
    metaDescription:
      'Finden Sie geprüfte Entrümpelungsfirmen in Stuttgart. Kostenlos Angebote von verifizierten Stuttgarter Entrümpelungsfirmen vergleichen – Erfahrung mit Talkessel, Filder und Schwabenland.',
    metaKeywords:
      'Entrümpelung & Entsorgung Stuttgart, Entrümpelungsfirma Stuttgart, Entrümpelungskosten Stuttgart',
    heroTitleStart: 'Ihre Entrümpelung & Entsorgung in',
    heroTitleHighlight: 'Stuttgart.',
    heroSubtitle:
      'Vergleichen Sie kostenlos geprüfte Stuttgarter Entrümpelungsfirmen – schnell, diskret und mit Erfahrung für Talkessel, Filder und Schwabenland.',
    heroCtaPrimary: 'Jetzt Angebote erhalten',
    heroCtaSecondary: 'Stuttgarter Firmen ansehen',
    heroStatFirms: '110+ Stuttgarter Firmen',
    heroStatMoves: '230+ vermittelte Aufträge',
    heroStatRating: '4,7/5 Bewertung',
    benefitsTitle: 'Ihre Vorteile mit RegionalUmzug24 für Entrümpelung & Entsorgung in Stuttgart',
    benefitsSubtitle:
      'Warum sich Stuttgarter Kund:innen für unsere Vermittlungsplattform entscheiden',
    benefitFreeTitle: '100 % kostenlos',
    benefitFreeDesc: 'Anfrage und Vergleich sind für Sie komplett kostenfrei und unverbindlich.',
    benefitVettedTitle: 'Geprüfte Entsorgungsbetriebe',
    benefitVettedDesc:
      'Wir vermitteln ausschließlich geprüfte Stuttgarter Entrümpelungsfirmen mit Versicherung und Fachnachweis.',
    benefitFastTitle: 'Schnelle Termine',
    benefitFastDesc:
      'Erhalten Sie Angebote innerhalb von 24 Stunden und buchen Sie Ihren Wunschtermin – auch kurzfristig.',
    servicesTitle: 'Unsere Entrümpelung & Entsorgung-Services in Stuttgart',
    servicesSubtitle: 'Welche Art von Entrümpelung benötigen Sie in Stuttgart?',
    serviceApartmentTitle: 'Wohnungsauflösung',
    serviceApartmentDesc:
      'Komplette oder teilweise Auflösung Ihrer Wohnung in Stuttgart inkl. fachgerechter Entsorgung.',
    serviceSecondaryTitle: 'Haushaltsauflösung',
    serviceSecondaryDesc:
      'Auflösung ganzer Haushalte in Stuttgart – einfühlsam, diskret und mit Entsorgungsnachweis.',
    serviceThirdTitle: 'Keller- & Dachbodenentrümpelung',
    serviceThirdDesc:
      'Endlich wieder Platz in Keller und Dachboden in Stuttgart – inkl. Sperrmüll- und Sondermüllabholung.',
    serviceFourthTitle: 'Gartenentrümpelung',
    serviceFourthDesc:
      'Entfernung von Gartenabfällen, alten Möbeln und Bauschutt in Stuttgart – inkl. Abtransport.',
    processTitle: 'So läuft Ihre Entrümpelung & Entsorgung in Stuttgart ab',
    processSubtitle:
      'In drei einfachen Schritten zu Ihrer passenden Entrümpelungsfirma in Stuttgart',
    step1Title: 'Anfrage stellen',
    step1Desc: 'Beschreiben Sie Ihr Anliegen in Stuttgart in wenigen Schritten online.',
    step2Title: 'Stuttgarter Firmen erhalten',
    step2Desc: 'Passende Entrümpelungsfirmen aus Stuttgart senden Ihnen ihre Angebote.',
    step3Title: 'Firma wählen',
    step3Desc: 'Vergleichen Sie Bewertungen und wählen Sie das beste Angebot in Stuttgart.',
    statsTitle: 'Entrümpelung & Entsorgung in Stuttgart in Zahlen',
    statsSubtitle: 'Vertrauen der Stuttgarter Kund:innen auf RegionalUmzug24',
    statFirms: '110+',
    statFirmsLabel: 'Stuttgarter Entrümpelungsfirmen',
    statJobs: '230+',
    statJobsLabel: 'Vermittelte Aufträge',
    statRating: '4,7/5',
    statRatingLabel: 'Kundenbewertung',
    trustTitle: 'Geprüfte Stuttgarter Entrümpelungsfirmen',
    trustSubtitle: 'Sicherheit und Qualität – speziell für Stuttgart',
    trustVerifiedTitle: 'Verifizierte Stuttgarter Firmen',
    trustVerifiedDesc:
      'Jede Firma wird auf Gewerbeanmeldung, Versicherung und Entrümpelung-Erfahrung geprüft.',
    trustGdprTitle: 'DSGVO-konform',
    trustGdprDesc: 'Ihre Daten werden verschlüsselt übertragen und nicht an Dritte weitergegeben.',
    trustFreeTitle: '100 % kostenlos',
    trustFreeDesc:
      'Die Nutzung von RegionalUmzug24 ist für Sie komplett kostenfrei – ohne versteckte Gebühren.',
    faqTitle: 'Häufige Fragen zur Entrümpelung & Entsorgung in Stuttgart',
    faqSubtitle:
      'Antworten auf die wichtigsten Fragen rund um Entrümpelung & Entsorgung in Stuttgart',
    faq1Question: 'Was kostet eine Entrümpelung in Stuttgart?',
    faq1Answer:
      'Die Kosten hängen von Volumen, Stockwerk und Entsorgungsart ab. Über uns erhalten Sie kostenlos vergleichbare Angebote aus Stuttgart.',
    faq2Question: 'Werden die Sachen in Stuttgart fachgerecht entsorgt?',
    faq2Answer:
      'Ja, alle vermittelten {cityAdj} Firmen entsorgen fachgerecht mit Nachweis. Wertstoffe werden recycelt, Restmüll ordnungsgemäß entsorgt.',
    faq3Question: 'Wie schnell geht eine Entrümpelung in Stuttgart?',
    faq3Answer:
      'In der Regel erhalten Sie innerhalb von 24 Stunden die ersten Angebote. Viele {cityAdj} Firmen bieten Termine innerhalb weniger Tage an.',
    faq4Question: 'Kann ich auch nur einzelne Räume in Stuttgart entrümpeln lassen?',
    faq4Answer:
      'Ja, Sie können die Anfrage auf einzelne Räume, Keller oder Dachboden in Stuttgart beschränken – die Firmen erstellen ein passendes Angebot.',
    faq5Question: 'Was passiert mit verwertbaren Gegenständen in Stuttgart?',
    faq5Answer:
      'Wertvolle oder verwertbare Gegenstände können vorab aussortiert werden. Klären Sie Details direkt mit der gewählten {cityAdj} Firma.',
    ctaTitle: 'Bereit für Ihre Entrümpelung & Entsorgung in Stuttgart?',
    ctaSubtitle:
      'Erstellen Sie jetzt kostenlos Ihre Anfrage und erhalten Sie Angebote von geprüften Stuttgarter Entrümpelungsfirmen.',
    ctaPrimary: 'Jetzt Anfrage erstellen',
    ctaSecondary: 'Stuttgarter Firmen ansehen',
  },
  disposalStuttgartDirectory: {
    metaTitle: 'Entrümpelungsfirmen Stuttgart | RegionalUmzug24 – Stuttgarter Firmen vergleichen',
    metaDescription:
      'Liste geprüfter Entrümpelungsfirmen in Stuttgart. Vergleichen Sie Bewertungen, Spezialgebiete und Preise von stuttgarter Entrümpelungsfirmen im PLZ-Bereich 70.',
    metaKeywords:
      'Entrümpelungsfirmen Stuttgart, stuttgarter Entrümpelungsfirma, Entrümpelungs Stuttgart Firmen',
    pageTitle: 'Entrümpelungsfirmen in Stuttgart',
    pageSubtitle:
      'Entdecken Sie geprüfte stuttgarter Entrümpelungsfirmen mit echten Bewertungen. PLZ-Bereich 70 – abgestimmt auf Stuttgart.',
    filterTitle: 'Filter',
    filterPremium: 'Nur Premium-Firmen',
    filterVerified: 'Nur verifizierte Firmen',
    filterPostalTitle: 'PLZ-Bereich',
    filterPostalAll: 'Alle PLZ-Bereiche',
    sortTitle: 'Sortierung',
    sortRating: 'Beste Bewertung',
    sortOrders: 'Meiste Aufträge',
    sortNewest: 'Neueste',
    resultCount: '{{count}} Firmen gefunden',
    emptyTitle: 'Keine Firmen gefunden',
    emptyDescription:
      'Mit den aktuellen Filtern wurden keine stuttgarter Entrümpelungsfirmen gefunden. Versuchen Sie, die Filter anzupassen.',
    emptyReset: 'Filter zurücksetzen',
    loadingTitle: 'Lade stuttgarter Entrümpelungsfirmen...',
    errorTitle: 'Fehler beim Laden',
    errorDescription:
      'Die Liste der stuttgarter Entrümpelungsfirmen konnte nicht geladen werden. Bitte versuchen Sie es erneut.',
    errorRetry: 'Erneut versuchen',
    paginationPrev: 'Zurück',
    paginationNext: 'Weiter',
    paginationPage: 'Seite {{page}} von {{total}}',
    filterPostal70: 'PLZ 70 (Talkessel)',
  },
  cleaningBerlinLanding: {
    metaTitle: 'Reinigung Berlin | RegionalUmzug24 – Reinigungsfirmen vergleichen',
    metaDescription:
      'Finden Sie geprüfte Reinigungsfirmen in Berlin. Kostenlos Angebote von verifizierten Berliner Reinigungsfirmen vergleichen – Erfahrung in allen 12 Bezirken, von Mitte bis Köpenick.',
    metaKeywords:
      'Reinigung Berlin, Reinigungsfirma Berlin, Reinigungskosten Berlin, Reinigung Charlottenburg, Reinigung Friedrichshain',
    heroTitleStart: 'Ihre Reinigung in',
    heroTitleHighlight: 'Berlin.',
    heroSubtitle:
      'Vergleichen Sie kostenlos geprüfte Berliner Reinigungsfirmen – schnell, diskret und mit Erfahrung in Mitte, Charlottenburg, Friedrichshain-Kreuzberg, Pankow und allen weiteren Bezirken.',
    heroCtaPrimary: 'Jetzt Angebote erhalten',
    heroCtaSecondary: 'Berliner Firmen ansehen',
    heroStatFirms: '180+ Berliner Firmen',
    heroStatMoves: '320+ vermittelte Aufträge',
    heroStatRating: '4,8/5 Bewertung',
    benefitsTitle: 'Ihre Vorteile mit RegionalUmzug24 für Reinigung in Berlin',
    benefitsSubtitle: 'Warum sich Berliner Kund:innen für unsere Vermittlungsplattform entscheiden',
    benefitFreeTitle: '100 % kostenlos',
    benefitFreeDesc: 'Anfrage und Vergleich sind für Sie komplett kostenfrei und unverbindlich.',
    benefitVettedTitle: 'Geprüfte Reinigungskräfte',
    benefitVettedDesc:
      'Wir vermitteln ausschließlich geprüfte Berliner Reinigungsfirmen mit Versicherung und Fachnachweis.',
    benefitFastTitle: 'Schnelle Termine',
    benefitFastDesc:
      'Erhalten Sie Angebote innerhalb von 24 Stunden und buchen Sie Ihren Wunschtermin – auch kurzfristig.',
    servicesTitle: 'Unsere Reinigung-Services in Berlin',
    servicesSubtitle: 'Welche Art von Reinigung benötigen Sie in Berlin?',
    serviceApartmentTitle: 'Wohnungsreinigung',
    serviceApartmentDesc:
      'Gründliche Reinigung Ihrer Wohnung in Berlin – perfekt vor oder nach einem Umzug in Mitte, Charlottenburg oder Pankow.',
    serviceSecondaryTitle: 'Büroreinigung',
    serviceSecondaryDesc:
      'Regelmäßige oder einmalige professionelle Reinigung Ihres Büros in Berlin – auch in Mitte und am Hackeschen Markt.',
    serviceThirdTitle: 'Endreinigung',
    serviceThirdDesc:
      'Besenreine Übergabe Ihrer Wohnung in Berlin inkl. Abnahmegarantie mit dem Vermieter – in allen Bezirken.',
    serviceFourthTitle: 'Fensterreinigung',
    serviceFourthDesc:
      'Streifenfreie Fenster, Rahmen und Fensterbänke in Berlin – auch in schwer zugänglichen Höhen und Gründerzeit-Altbauten.',
    processTitle: 'So läuft Ihre Reinigung in Berlin ab',
    processSubtitle: 'In drei einfachen Schritten zu Ihrer passenden Reinigungsfirma in Berlin',
    step1Title: 'Anfrage stellen',
    step1Desc:
      'Beschreiben Sie Ihr Anliegen in Berlin in wenigen Schritten online – mit Bezirk und Wunschtermin.',
    step2Title: 'Berliner Firmen erhalten',
    step2Desc: 'Passende Reinigungsfirmen aus Ihrem Berliner Bezirk senden Ihnen ihre Angebote.',
    step3Title: 'Firma wählen',
    step3Desc: 'Vergleichen Sie Bewertungen und wählen Sie das beste Angebot in Berlin.',
    statsTitle: 'Reinigung in Berlin in Zahlen',
    statsSubtitle: 'Vertrauen der Berliner Kund:innen auf RegionalUmzug24',
    statFirms: '180+',
    statFirmsLabel: 'Berliner Reinigungsfirmen',
    statJobs: '320+',
    statJobsLabel: 'Vermittelte Aufträge',
    statRating: '4,8/5',
    statRatingLabel: 'Kundenbewertung',
    trustTitle: 'Geprüfte Berliner Reinigungsfirmen',
    trustSubtitle: 'Sicherheit und Qualität – speziell für Berlin',
    trustVerifiedTitle: 'Verifizierte Berliner Firmen',
    trustVerifiedDesc:
      'Jede Firma wird auf Gewerbeanmeldung, Versicherung und Reinigung-Erfahrung geprüft.',
    trustGdprTitle: 'DSGVO-konform',
    trustGdprDesc: 'Ihre Daten werden verschlüsselt übertragen und nicht an Dritte weitergegeben.',
    trustFreeTitle: '100 % kostenlos',
    trustFreeDesc:
      'Die Nutzung von RegionalUmzug24 ist für Sie komplett kostenfrei – ohne versteckte Gebühren.',
    faqTitle: 'Häufige Fragen zur Reinigung in Berlin',
    faqSubtitle: 'Antworten auf die wichtigsten Fragen rund um Reinigung in Berlin',
    faq1Question: 'Was kostet eine Reinigung in Berlin?',
    faq1Answer:
      'Die Kosten hängen von Größe, Zustand und Bezirk ab. Über uns erhalten Sie kostenlos vergleichbare Angebote aus Berlin.',
    faq2Question: 'Sind die Reinigungsfirmen in Berlin versichert?',
    faq2Answer:
      'Ja, alle vermittelten {cityAdj} Reinigungsfirmen sind geprüft und haftpflichtversichert. So sind Sie bei eventuellen Schäden abgesichert.',
    faq3Question: 'Wie schnell bekomme ich Angebote aus Berlin?',
    faq3Answer:
      'In der Regel erhalten Sie innerhalb von 24 Stunden die ersten Angebote von passenden Reinigungsfirmen in Berlin und Umgebung.',
    faq4Question: 'Kann ich kurzfristig eine Reinigung in Berlin buchen?',
    faq4Answer:
      'Ja, viele Reinigungsfirmen in Berlin bieten auch kurzfristige Termine an. Geben Sie Ihren Wunschtermin einfach in der Anfrage an.',
    faq5Question: 'Welche Reinigungsleistungen werden in Berlin angeboten?',
    faq5Answer:
      'Von der Wohnungsreinigung über die Büroreinigung bis zur Fenster- und Teppichreinigung – die vermittelten Firmen decken das gesamte Spektrum ab.',
    ctaTitle: 'Bereit für Ihre Reinigung in Berlin?',
    ctaSubtitle:
      'Erstellen Sie jetzt kostenlos Ihre Anfrage und erhalten Sie Angebote von geprüften Berliner Reinigungsfirmen.',
    ctaPrimary: 'Jetzt Anfrage erstellen',
    ctaSecondary: 'Berliner Firmen ansehen',
  },
  cleaningBerlinDirectory: {
    metaTitle: 'Reinigungsfirmen Berlin | RegionalUmzug24 – Berliner Firmen vergleichen',
    metaDescription:
      'Liste geprüfter Reinigungsfirmen in Berlin. Vergleichen Sie Bewertungen, Spezialgebiete und Preise von berliner Reinigungsfirmen im PLZ-Bereich 10-14.',
    metaKeywords:
      'Reinigungsfirmen Berlin, berliner Reinigungsfirma, Reinigungs Berlin Firmen, Reinigung Mitte, Reinigung Charlottenburg',
    pageTitle: 'Reinigungsfirmen in Berlin',
    pageSubtitle:
      'Entdecken Sie geprüfte berliner Reinigungsfirmen mit echten Bewertungen. PLZ-Bereich 10-14 – von Mitte bis Köpenick.',
    filterTitle: 'Filter',
    filterPremium: 'Nur Premium-Firmen',
    filterVerified: 'Nur verifizierte Firmen',
    filterPostalTitle: 'PLZ-Bereich',
    filterPostalAll: 'Alle PLZ-Bereiche',
    sortTitle: 'Sortierung',
    sortRating: 'Beste Bewertung',
    sortOrders: 'Meiste Aufträge',
    sortNewest: 'Neueste',
    resultCount: '{{count}} Firmen gefunden',
    emptyTitle: 'Keine Firmen gefunden',
    emptyDescription:
      'Mit den aktuellen Filtern wurden keine berliner Reinigungsfirmen gefunden. Versuchen Sie, die Filter anzupassen.',
    emptyReset: 'Filter zurücksetzen',
    loadingTitle: 'Lade berliner Reinigungsfirmen...',
    errorTitle: 'Fehler beim Laden',
    errorDescription:
      'Die Liste der berliner Reinigungsfirmen konnte nicht geladen werden. Bitte versuchen Sie es erneut.',
    errorRetry: 'Erneut versuchen',
    paginationPrev: 'Zurück',
    paginationNext: 'Weiter',
    paginationPage: 'Seite {{page}} von {{total}}',
    filterPostal10: 'PLZ 10 (Mitte, Charlottenburg)',
    filterPostal11: 'PLZ 11 (Tiergarten, Friedrichshain)',
    filterPostal12: 'PLZ 12 (Neukölln, Tempelhof, Steglitz)',
    filterPostal13: 'PLZ 13 (Pankow, Weißensee, Reinickendorf)',
    filterPostal14: 'PLZ 14 (Wilmersdorf, Zehlendorf, Köpenick)',
  },
  disposalBerlinLanding: {
    metaTitle:
      'Entrümpelung & Entsorgung Berlin | RegionalUmzug24 – Entrümpelungsfirmen vergleichen',
    metaDescription:
      'Finden Sie geprüfte Entrümpelungsfirmen in Berlin. Kostenlos Angebote von verifizierten Berliner Entrümpelungsfirmen vergleichen – Erfahrung in allen 12 Bezirken und mit BSR-Sperrmüll.',
    metaKeywords:
      'Entrümpelung & Entsorgung Berlin, Entrümpelungsfirma Berlin, Entrümpelungskosten Berlin, BSR Sperrmüll Berlin',
    heroTitleStart: 'Ihre Entrümpelung & Entsorgung in',
    heroTitleHighlight: 'Berlin.',
    heroSubtitle:
      'Vergleichen Sie kostenlos geprüfte Berliner Entrümpelungsfirmen – schnell, diskret und mit Erfahrung für alle 12 Bezirke, inkl. BSR-Sperrmüllabholung.',
    heroCtaPrimary: 'Jetzt Angebote erhalten',
    heroCtaSecondary: 'Berliner Firmen ansehen',
    heroStatFirms: '140+ Berliner Firmen',
    heroStatMoves: '270+ vermittelte Aufträge',
    heroStatRating: '4,7/5 Bewertung',
    benefitsTitle: 'Ihre Vorteile mit RegionalUmzug24 für Entrümpelung & Entsorgung in Berlin',
    benefitsSubtitle: 'Warum sich Berliner Kund:innen für unsere Vermittlungsplattform entscheiden',
    benefitFreeTitle: '100 % kostenlos',
    benefitFreeDesc: 'Anfrage und Vergleich sind für Sie komplett kostenfrei und unverbindlich.',
    benefitVettedTitle: 'Geprüfte Entsorgungsbetriebe',
    benefitVettedDesc:
      'Wir vermitteln ausschließlich geprüfte Berliner Entrümpelungsfirmen mit Versicherung und Fachnachweis.',
    benefitFastTitle: 'Schnelle Termine',
    benefitFastDesc:
      'Erhalten Sie Angebote innerhalb von 24 Stunden und buchen Sie Ihren Wunschtermin – auch kurzfristig.',
    servicesTitle: 'Unsere Entrümpelung & Entsorgung-Services in Berlin',
    servicesSubtitle: 'Welche Art von Entrümpelung benötigen Sie in Berlin?',
    serviceApartmentTitle: 'Wohnungsauflösung',
    serviceApartmentDesc:
      'Komplette oder teilweise Auflösung Ihrer Wohnung in Berlin inkl. fachgerechter Entsorgung und BSR-Abmeldung.',
    serviceSecondaryTitle: 'Haushaltsauflösung',
    serviceSecondaryDesc:
      'Auflösung ganzer Haushalte in Berlin – einfühlsam, diskret und mit Entsorgungsnachweis für Nachlass oder Umzug ins Pflegeheim.',
    serviceThirdTitle: 'Keller- & Dachbodenentrümpelung',
    serviceThirdDesc:
      'Endlich wieder Platz in Keller und Dachboden in Berlin – inkl. Sperrmüllabholung und Sondermüllentsorgung in Ihrem Bezirk.',
    serviceFourthTitle: 'Gartenentrümpelung',
    serviceFourthDesc:
      'Entfernung von Gartenabfällen, alten Möbeln und Bauschutt in Berlin – inkl. Abtransport über die BSR-Recyclinghöfe.',
    processTitle: 'So läuft Ihre Entrümpelung & Entsorgung in Berlin ab',
    processSubtitle: 'In drei einfachen Schritten zu Ihrer passenden Entrümpelungsfirma in Berlin',
    step1Title: 'Anfrage stellen',
    step1Desc:
      'Beschreiben Sie Ihr Anliegen in Berlin in wenigen Schritten online – mit Bezirk und Wunschtermin.',
    step2Title: 'Berliner Firmen erhalten',
    step2Desc: 'Passende Entrümpelungsfirmen aus Ihrem Berliner Bezirk senden Ihnen ihre Angebote.',
    step3Title: 'Firma wählen',
    step3Desc: 'Vergleichen Sie Bewertungen und wählen Sie das beste Angebot in Berlin.',
    statsTitle: 'Entrümpelung & Entsorgung in Berlin in Zahlen',
    statsSubtitle: 'Vertrauen der Berliner Kund:innen auf RegionalUmzug24',
    statFirms: '140+',
    statFirmsLabel: 'Berliner Entrümpelungsfirmen',
    statJobs: '270+',
    statJobsLabel: 'Vermittelte Aufträge',
    statRating: '4,7/5',
    statRatingLabel: 'Kundenbewertung',
    trustTitle: 'Geprüfte Berliner Entrümpelungsfirmen',
    trustSubtitle: 'Sicherheit und Qualität – speziell für Berlin',
    trustVerifiedTitle: 'Verifizierte Berliner Firmen',
    trustVerifiedDesc:
      'Jede Firma wird auf Gewerbeanmeldung, Versicherung und Entrümpelung-Erfahrung geprüft.',
    trustGdprTitle: 'DSGVO-konform',
    trustGdprDesc: 'Ihre Daten werden verschlüsselt übertragen und nicht an Dritte weitergegeben.',
    trustFreeTitle: '100 % kostenlos',
    trustFreeDesc:
      'Die Nutzung von RegionalUmzug24 ist für Sie komplett kostenfrei – ohne versteckte Gebühren.',
    faqTitle: 'Häufige Fragen zur Entrümpelung & Entsorgung in Berlin',
    faqSubtitle: 'Antworten auf die wichtigsten Fragen rund um Entrümpelung & Entsorgung in Berlin',
    faq1Question: 'Was kostet eine Entrümpelung in Berlin?',
    faq1Answer:
      'Die Kosten hängen von Volumen, Stockwerk und Bezirk ab. Über uns erhalten Sie kostenlos vergleichbare Angebote aus Berlin.',
    faq2Question: 'Werden die Sachen in Berlin fachgerecht entsorgt?',
    faq2Answer:
      'Ja, alle vermittelten {cityAdj} Firmen entsorgen fachgerecht mit Nachweis. Wertstoffe werden recycelt, Restmüll ordnungsgemäß über die BSR entsorgt.',
    faq3Question: 'Wie schnell geht eine Entrümpelung in Berlin?',
    faq3Answer:
      'In der Regel erhalten Sie innerhalb von 24 Stunden die ersten Angebote. Viele {cityAdj} Firmen bieten Termine innerhalb weniger Tage an.',
    faq4Question: 'Kann ich auch nur einzelne Räume in Berlin entrümpeln lassen?',
    faq4Answer:
      'Ja, Sie können die Anfrage auf einzelne Räume, Keller oder Dachboden in Berlin beschränken – die Firmen erstellen ein passendes Angebot.',
    faq5Question: 'Was passiert mit verwertbaren Gegenständen in Berlin?',
    faq5Answer:
      'Wertvolle oder verwertbare Gegenstände können vorab aussortiert werden. Klären Sie Details direkt mit der gewählten {cityAdj} Firma.',
    ctaTitle: 'Bereit für Ihre Entrümpelung & Entsorgung in Berlin?',
    ctaSubtitle:
      'Erstellen Sie jetzt kostenlos Ihre Anfrage und erhalten Sie Angebote von geprüften Berliner Entrümpelungsfirmen.',
    ctaPrimary: 'Jetzt Anfrage erstellen',
    ctaSecondary: 'Berliner Firmen ansehen',
  },
  disposalBerlinDirectory: {
    metaTitle: 'Entrümpelungsfirmen Berlin | RegionalUmzug24 – Berliner Firmen vergleichen',
    metaDescription:
      'Liste geprüfter Entrümpelungsfirmen in Berlin. Vergleichen Sie Bewertungen, Spezialgebiete und Preise von berliner Entrümpelungsfirmen im PLZ-Bereich 10-14.',
    metaKeywords:
      'Entrümpelungsfirmen Berlin, berliner Entrümpelungsfirma, Entrümpelungs Berlin Firmen, Haushaltsauflösung Berlin, BSR Sperrmüll',
    pageTitle: 'Entrümpelungsfirmen in Berlin',
    pageSubtitle:
      'Entdecken Sie geprüfte berliner Entrümpelungsfirmen mit echten Bewertungen. PLZ-Bereich 10-14 – von Mitte bis Köpenick.',
    filterTitle: 'Filter',
    filterPremium: 'Nur Premium-Firmen',
    filterVerified: 'Nur verifizierte Firmen',
    filterPostalTitle: 'PLZ-Bereich',
    filterPostalAll: 'Alle PLZ-Bereiche',
    sortTitle: 'Sortierung',
    sortRating: 'Beste Bewertung',
    sortOrders: 'Meiste Aufträge',
    sortNewest: 'Neueste',
    resultCount: '{{count}} Firmen gefunden',
    emptyTitle: 'Keine Firmen gefunden',
    emptyDescription:
      'Mit den aktuellen Filtern wurden keine berliner Entrümpelungsfirmen gefunden. Versuchen Sie, die Filter anzupassen.',
    emptyReset: 'Filter zurücksetzen',
    loadingTitle: 'Lade berliner Entrümpelungsfirmen...',
    errorTitle: 'Fehler beim Laden',
    errorDescription:
      'Die Liste der berliner Entrümpelungsfirmen konnte nicht geladen werden. Bitte versuchen Sie es erneut.',
    errorRetry: 'Erneut versuchen',
    paginationPrev: 'Zurück',
    paginationNext: 'Weiter',
    paginationPage: 'Seite {{page}} von {{total}}',
    filterPostal10: 'PLZ 10 (Mitte, Charlottenburg)',
    filterPostal11: 'PLZ 11 (Tiergarten, Friedrichshain)',
    filterPostal12: 'PLZ 12 (Neukölln, Tempelhof, Steglitz)',
    filterPostal13: 'PLZ 13 (Pankow, Weißensee, Reinickendorf)',
    filterPostal14: 'PLZ 14 (Wilmersdorf, Zehlendorf, Köpenick)',
  },
};

const enResources = {
  cleaningHamburgLanding: {
    metaTitle: 'Cleaning Hamburg | RegionalUmzug24 – Compare Cleaning companies',
    metaDescription:
      'Find vetted cleaning companies in Hamburg. Compare free quotes from verified Hamburg providers with experience for harbour, Elbe and Speicherstadt.',
    metaKeywords: 'Cleaning Hamburg, cleaning company Hamburg, cleaning costs Hamburg',
    heroTitleStart: 'Your cleaning in',
    heroTitleHighlight: 'Hamburg.',
    heroSubtitle:
      'Compare vetted Hamburg cleaning companies for free – fast, discreet and experienced with harbour, Elbe and Speicherstadt.',
    heroCtaPrimary: 'Get Free Quotes',
    heroCtaSecondary: 'View Hamburg Companies',
    heroStatFirms: '140+ Hamburg companies',
    heroStatMoves: '280+ matched jobs',
    heroStatRating: '4.8/5 rating',
    benefitsTitle: 'Your benefits with RegionalUmzug24 for cleaning in Hamburg',
    benefitsSubtitle: 'Why Hamburg customers choose our matching platform',
    benefitFreeTitle: '100% free of charge',
    benefitFreeDesc:
      'Submitting a request and comparing quotes is completely free and non-binding.',
    benefitVettedTitle: 'Vetted Cleaning Pros',
    benefitVettedDesc:
      'We match only vetted Hamburg cleaning companies with insurance and certification.',
    benefitFastTitle: 'Fast Appointments',
    benefitFastDesc:
      'Receive quotes within 24 hours and book your preferred date – even short notice.',
    servicesTitle: 'Our cleaning services in Hamburg',
    servicesSubtitle: 'What kind of cleaning do you need in Hamburg?',
    serviceApartmentTitle: 'Apartment Cleaning',
    serviceApartmentDesc:
      'Thorough cleaning of your apartment – perfect before or after a move in Hamburg.',
    serviceSecondaryTitle: 'Office Cleaning',
    serviceSecondaryDesc:
      'Regular or one-off professional cleaning of your office or practice in Hamburg.',
    serviceThirdTitle: 'Move-Out Cleaning',
    serviceThirdDesc:
      'Broom-clean handover of your Hamburg apartment including acceptance guarantee with the landlord.',
    serviceFourthTitle: 'Window Cleaning',
    serviceFourthDesc:
      'Streak-free windows, frames and sills in Hamburg – including hard-to-reach heights.',
    processTitle: 'How your cleaning in Hamburg works',
    processSubtitle: 'In three simple steps to the right cleaning company in Hamburg',
    step1Title: 'Submit a request',
    step1Desc: 'Describe your cleaning need in Hamburg in just a few steps online.',
    step2Title: 'Receive Hamburg quotes',
    step2Desc: 'Suitable cleaning companies from Hamburg send you their offers.',
    step3Title: 'Choose a company',
    step3Desc: 'Compare ratings and pick the best cleaning offer in Hamburg.',
    statsTitle: 'Cleaning in Hamburg by the numbers',
    statsSubtitle: 'Hamburg customers trust RegionalUmzug24',
    statFirms: '140+',
    statFirmsLabel: 'Hamburg cleaning companies',
    statJobs: '280+',
    statJobsLabel: 'Matched jobs',
    statRating: '4.8/5',
    statRatingLabel: 'Customer rating',
    trustTitle: 'Vetted Hamburg cleaning companies',
    trustSubtitle: 'Safety and quality – tailored to Hamburg',
    trustVerifiedTitle: 'Verified Hamburg companies',
    trustVerifiedDesc:
      'Every company is checked for business registration, insurance and cleaning experience.',
    trustGdprTitle: 'GDPR compliant',
    trustGdprDesc: 'Your data is transmitted securely and never shared with third parties.',
    trustFreeTitle: '100% free',
    trustFreeDesc: 'Using RegionalUmzug24 is completely free for you – no hidden fees.',
    faqTitle: 'Frequently asked questions about cleaning in Hamburg',
    faqSubtitle: 'Answers to the most common questions about cleaning in Hamburg',
    faq1Question: 'How much does cleaning in Hamburg cost?',
    faq1Answer:
      'The cost depends on size, condition and type of cleaning. Through us you will receive free comparable quotes from Hamburg.',
    faq2Question: 'Are cleaning companies in Hamburg insured?',
    faq2Answer:
      'Yes, all matched {cityAdjEn} cleaning companies are vetted and have liability insurance. You are covered in case of damage.',
    faq3Question: 'How fast will I receive Hamburg quotes?',
    faq3Answer:
      'Usually you will receive the first quotes from suitable cleaning companies in Hamburg and surroundings within 24 hours.',
    faq4Question: 'Can I book a short-notice cleaning in Hamburg?',
    faq4Answer:
      'Yes, many cleaning companies in Hamburg also offer short-notice appointments. Simply enter your preferred date in the request.',
    faq5Question: 'Which cleaning services are offered in Hamburg?',
    faq5Answer:
      'From apartment cleaning to office, window and carpet cleaning – the matched companies cover the full spectrum.',
    ctaTitle: 'Ready for your cleaning in Hamburg?',
    ctaSubtitle:
      'Create your free request now and receive quotes from vetted Hamburg cleaning companies.',
    ctaPrimary: 'Create Request Now',
    ctaSecondary: 'View Hamburg Companies',
  },
  cleaningHamburgDirectory: {
    metaTitle: 'Cleaning Companies Hamburg | RegionalUmzug24 – Compare Hamburg Firms',
    metaDescription:
      'List of vetted cleaning companies in Hamburg. Compare ratings, specialties and prices of Hamburg providers in postal code area 20-22.',
    metaKeywords: 'cleaning companies Hamburg, Hamburg cleaning company, cleaning Hamburg firms',
    pageTitle: 'Cleaning Companies in Hamburg',
    pageSubtitle:
      'Discover vetted Hamburg cleaning companies with real reviews. Postal code area 20-22 – tailored to Hamburg.',
    filterTitle: 'Filters',
    filterPremium: 'Premium companies only',
    filterVerified: 'Verified companies only',
    filterPostalTitle: 'Postal code area',
    filterPostalAll: 'All postal code areas',
    sortTitle: 'Sort by',
    sortRating: 'Best rating',
    sortOrders: 'Most orders',
    sortNewest: 'Newest',
    resultCount: '{{count}} companies found',
    emptyTitle: 'No companies found',
    emptyDescription:
      'No Hamburg cleaning companies match the current filters. Try adjusting the filters.',
    emptyReset: 'Reset filters',
    loadingTitle: 'Loading Hamburg cleaning companies...',
    errorTitle: 'Error loading',
    errorDescription:
      'The list of Hamburg cleaning companies could not be loaded. Please try again.',
    errorRetry: 'Retry',
    paginationPrev: 'Previous',
    paginationNext: 'Next',
    paginationPage: 'Page {{page}} of {{total}}',
    filterPostal20: 'PLZ 20 (Innenstadt)',
    filterPostal21: 'PLZ 21 (Norden)',
    filterPostal22: 'PLZ 22 (Osten)',
  },
  disposalHamburgLanding: {
    metaTitle: 'Clearance & Disposal Hamburg | RegionalUmzug24 – Compare Disposal companies',
    metaDescription:
      'Find vetted disposal companies in Hamburg. Compare free quotes from verified Hamburg providers with experience for harbour, Elbe and Speicherstadt.',
    metaKeywords: 'Clearance & Disposal Hamburg, disposal company Hamburg, disposal costs Hamburg',
    heroTitleStart: 'Your disposal in',
    heroTitleHighlight: 'Hamburg.',
    heroSubtitle:
      'Compare vetted Hamburg disposal companies for free – fast, discreet and experienced with harbour, Elbe and Speicherstadt.',
    heroCtaPrimary: 'Get Free Quotes',
    heroCtaSecondary: 'View Hamburg Companies',
    heroStatFirms: '110+ Hamburg companies',
    heroStatMoves: '230+ matched jobs',
    heroStatRating: '4.7/5 rating',
    benefitsTitle: 'Your benefits with RegionalUmzug24 for disposal in Hamburg',
    benefitsSubtitle: 'Why Hamburg customers choose our matching platform',
    benefitFreeTitle: '100% free of charge',
    benefitFreeDesc:
      'Submitting a request and comparing quotes is completely free and non-binding.',
    benefitVettedTitle: 'Vetted Disposal Specialists',
    benefitVettedDesc:
      'We match only vetted Hamburg disposal companies with insurance and certification.',
    benefitFastTitle: 'Fast Appointments',
    benefitFastDesc:
      'Receive quotes within 24 hours and book your preferred date – even short notice.',
    servicesTitle: 'Our disposal services in Hamburg',
    servicesSubtitle: 'What kind of disposal do you need in Hamburg?',
    serviceApartmentTitle: 'Apartment Clearance',
    serviceApartmentDesc:
      'Complete or partial clearance of your apartment in Hamburg including proper disposal.',
    serviceSecondaryTitle: 'House Clearance',
    serviceSecondaryDesc:
      'Full household clearance in Hamburg – sensitive, discreet and with disposal certificate.',
    serviceThirdTitle: 'Basement & Attic Clearance',
    serviceThirdDesc:
      'Finally space in your basement and attic in Hamburg – including bulky and hazardous waste collection.',
    serviceFourthTitle: 'Garden Clearance',
    serviceFourthDesc:
      'Removal of garden waste, old furniture and debris in Hamburg – including transport.',
    processTitle: 'How your disposal in Hamburg works',
    processSubtitle: 'In three simple steps to the right disposal company in Hamburg',
    step1Title: 'Submit a request',
    step1Desc: 'Describe your disposal need in Hamburg in just a few steps online.',
    step2Title: 'Receive Hamburg quotes',
    step2Desc: 'Suitable disposal companies from Hamburg send you their offers.',
    step3Title: 'Choose a company',
    step3Desc: 'Compare ratings and pick the best disposal offer in Hamburg.',
    statsTitle: 'Disposal in Hamburg by the numbers',
    statsSubtitle: 'Hamburg customers trust RegionalUmzug24',
    statFirms: '110+',
    statFirmsLabel: 'Hamburg disposal companies',
    statJobs: '230+',
    statJobsLabel: 'Matched jobs',
    statRating: '4.7/5',
    statRatingLabel: 'Customer rating',
    trustTitle: 'Vetted Hamburg disposal companies',
    trustSubtitle: 'Safety and quality – tailored to Hamburg',
    trustVerifiedTitle: 'Verified Hamburg companies',
    trustVerifiedDesc:
      'Every company is checked for business registration, insurance and disposal experience.',
    trustGdprTitle: 'GDPR compliant',
    trustGdprDesc: 'Your data is transmitted securely and never shared with third parties.',
    trustFreeTitle: '100% free',
    trustFreeDesc: 'Using RegionalUmzug24 is completely free for you – no hidden fees.',
    faqTitle: 'Frequently asked questions about disposal in Hamburg',
    faqSubtitle: 'Answers to the most common questions about disposal in Hamburg',
    faq1Question: 'How much does clearance in Hamburg cost?',
    faq1Answer:
      'The cost depends on volume, floor and disposal type. Through us you will receive free comparable quotes from Hamburg.',
    faq2Question: 'Is the waste properly disposed of in Hamburg?',
    faq2Answer:
      'Yes, all matched {cityAdjEn} companies dispose of waste properly with certificate. Recyclables are recycled, residual waste is properly disposed of.',
    faq3Question: 'How fast can clearance in Hamburg happen?',
    faq3Answer:
      'Usually you will receive the first quotes within 24 hours. Many {cityAdjEn} companies offer appointments within a few days.',
    faq4Question: 'Can I have only individual rooms cleared in Hamburg?',
    faq4Answer:
      'Yes, you can limit the request to individual rooms, basements or attics in Hamburg – the companies will create a suitable quote.',
    faq5Question: 'What happens to reusable items in Hamburg?',
    faq5Answer:
      'Valuable or reusable items can be sorted out in advance. Discuss details directly with the chosen {cityAdjEn} company.',
    ctaTitle: 'Ready for your disposal in Hamburg?',
    ctaSubtitle:
      'Create your free request now and receive quotes from vetted Hamburg disposal companies.',
    ctaPrimary: 'Create Request Now',
    ctaSecondary: 'View Hamburg Companies',
  },
  disposalHamburgDirectory: {
    metaTitle: 'Disposal Companies Hamburg | RegionalUmzug24 – Compare Hamburg Firms',
    metaDescription:
      'List of vetted disposal companies in Hamburg. Compare ratings, specialties and prices of Hamburg providers in postal code area 20-22.',
    metaKeywords: 'disposal companies Hamburg, Hamburg disposal company, disposal Hamburg firms',
    pageTitle: 'Disposal Companies in Hamburg',
    pageSubtitle:
      'Discover vetted Hamburg disposal companies with real reviews. Postal code area 20-22 – tailored to Hamburg.',
    filterTitle: 'Filters',
    filterPremium: 'Premium companies only',
    filterVerified: 'Verified companies only',
    filterPostalTitle: 'Postal code area',
    filterPostalAll: 'All postal code areas',
    sortTitle: 'Sort by',
    sortRating: 'Best rating',
    sortOrders: 'Most orders',
    sortNewest: 'Newest',
    resultCount: '{{count}} companies found',
    emptyTitle: 'No companies found',
    emptyDescription:
      'No Hamburg disposal companies match the current filters. Try adjusting the filters.',
    emptyReset: 'Reset filters',
    loadingTitle: 'Loading Hamburg disposal companies...',
    errorTitle: 'Error loading',
    errorDescription:
      'The list of Hamburg disposal companies could not be loaded. Please try again.',
    errorRetry: 'Retry',
    paginationPrev: 'Previous',
    paginationNext: 'Next',
    paginationPage: 'Page {{page}} of {{total}}',
    filterPostal20: 'PLZ 20 (Innenstadt)',
    filterPostal21: 'PLZ 21 (Norden)',
    filterPostal22: 'PLZ 22 (Osten)',
  },
  cleaningMunchenLanding: {
    metaTitle: 'Cleaning München | RegionalUmzug24 – Compare Cleaning companies',
    metaDescription:
      'Find vetted cleaning companies in München. Compare free quotes from verified München providers with experience for Maxvorstadt, Schwabing and Munich outskirts.',
    metaKeywords: 'Cleaning München, cleaning company München, cleaning costs München',
    heroTitleStart: 'Your cleaning in',
    heroTitleHighlight: 'München.',
    heroSubtitle:
      'Compare vetted Munich cleaning companies for free – fast, discreet and experienced with Maxvorstadt, Schwabing and Munich outskirts.',
    heroCtaPrimary: 'Get Free Quotes',
    heroCtaSecondary: 'View München Companies',
    heroStatFirms: '140+ Munich companies',
    heroStatMoves: '280+ matched jobs',
    heroStatRating: '4.8/5 rating',
    benefitsTitle: 'Your benefits with RegionalUmzug24 for cleaning in München',
    benefitsSubtitle: 'Why Munich customers choose our matching platform',
    benefitFreeTitle: '100% free of charge',
    benefitFreeDesc:
      'Submitting a request and comparing quotes is completely free and non-binding.',
    benefitVettedTitle: 'Vetted Cleaning Pros',
    benefitVettedDesc:
      'We match only vetted Munich cleaning companies with insurance and certification.',
    benefitFastTitle: 'Fast Appointments',
    benefitFastDesc:
      'Receive quotes within 24 hours and book your preferred date – even short notice.',
    servicesTitle: 'Our cleaning services in München',
    servicesSubtitle: 'What kind of cleaning do you need in München?',
    serviceApartmentTitle: 'Apartment Cleaning',
    serviceApartmentDesc:
      'Thorough cleaning of your apartment – perfect before or after a move in München.',
    serviceSecondaryTitle: 'Office Cleaning',
    serviceSecondaryDesc:
      'Regular or one-off professional cleaning of your office or practice in München.',
    serviceThirdTitle: 'Move-Out Cleaning',
    serviceThirdDesc:
      'Broom-clean handover of your München apartment including acceptance guarantee with the landlord.',
    serviceFourthTitle: 'Window Cleaning',
    serviceFourthDesc:
      'Streak-free windows, frames and sills in München – including hard-to-reach heights.',
    processTitle: 'How your cleaning in München works',
    processSubtitle: 'In three simple steps to the right cleaning company in München',
    step1Title: 'Submit a request',
    step1Desc: 'Describe your cleaning need in München in just a few steps online.',
    step2Title: 'Receive Munich quotes',
    step2Desc: 'Suitable cleaning companies from München send you their offers.',
    step3Title: 'Choose a company',
    step3Desc: 'Compare ratings and pick the best cleaning offer in München.',
    statsTitle: 'Cleaning in München by the numbers',
    statsSubtitle: 'Munich customers trust RegionalUmzug24',
    statFirms: '140+',
    statFirmsLabel: 'Munich cleaning companies',
    statJobs: '280+',
    statJobsLabel: 'Matched jobs',
    statRating: '4.8/5',
    statRatingLabel: 'Customer rating',
    trustTitle: 'Vetted Munich cleaning companies',
    trustSubtitle: 'Safety and quality – tailored to München',
    trustVerifiedTitle: 'Verified Munich companies',
    trustVerifiedDesc:
      'Every company is checked for business registration, insurance and cleaning experience.',
    trustGdprTitle: 'GDPR compliant',
    trustGdprDesc: 'Your data is transmitted securely and never shared with third parties.',
    trustFreeTitle: '100% free',
    trustFreeDesc: 'Using RegionalUmzug24 is completely free for you – no hidden fees.',
    faqTitle: 'Frequently asked questions about cleaning in München',
    faqSubtitle: 'Answers to the most common questions about cleaning in München',
    faq1Question: 'How much does cleaning in München cost?',
    faq1Answer:
      'The cost depends on size, condition and type of cleaning. Through us you will receive free comparable quotes from München.',
    faq2Question: 'Are cleaning companies in München insured?',
    faq2Answer:
      'Yes, all matched {cityAdjEn} cleaning companies are vetted and have liability insurance. You are covered in case of damage.',
    faq3Question: 'How fast will I receive München quotes?',
    faq3Answer:
      'Usually you will receive the first quotes from suitable cleaning companies in München and surroundings within 24 hours.',
    faq4Question: 'Can I book a short-notice cleaning in München?',
    faq4Answer:
      'Yes, many cleaning companies in München also offer short-notice appointments. Simply enter your preferred date in the request.',
    faq5Question: 'Which cleaning services are offered in München?',
    faq5Answer:
      'From apartment cleaning to office, window and carpet cleaning – the matched companies cover the full spectrum.',
    ctaTitle: 'Ready for your cleaning in München?',
    ctaSubtitle:
      'Create your free request now and receive quotes from vetted München cleaning companies.',
    ctaPrimary: 'Create Request Now',
    ctaSecondary: 'View München Companies',
  },
  cleaningMunchenDirectory: {
    metaTitle: 'Cleaning Companies München | RegionalUmzug24 – Compare Munich Firms',
    metaDescription:
      'List of vetted cleaning companies in München. Compare ratings, specialties and prices of Munich providers in postal code area 80-81.',
    metaKeywords: 'cleaning companies München, Munich cleaning company, cleaning München firms',
    pageTitle: 'Cleaning Companies in München',
    pageSubtitle:
      'Discover vetted Munich cleaning companies with real reviews. Postal code area 80-81 – tailored to München.',
    filterTitle: 'Filters',
    filterPremium: 'Premium companies only',
    filterVerified: 'Verified companies only',
    filterPostalTitle: 'Postal code area',
    filterPostalAll: 'All postal code areas',
    sortTitle: 'Sort by',
    sortRating: 'Best rating',
    sortOrders: 'Most orders',
    sortNewest: 'Newest',
    resultCount: '{{count}} companies found',
    emptyTitle: 'No companies found',
    emptyDescription:
      'No Munich cleaning companies match the current filters. Try adjusting the filters.',
    emptyReset: 'Reset filters',
    loadingTitle: 'Loading Munich cleaning companies...',
    errorTitle: 'Error loading',
    errorDescription:
      'The list of Munich cleaning companies could not be loaded. Please try again.',
    errorRetry: 'Retry',
    paginationPrev: 'Previous',
    paginationNext: 'Next',
    paginationPage: 'Page {{page}} of {{total}}',
    filterPostal80: 'PLZ 80 (Innenstadt)',
    filterPostal81: 'PLZ 81 (Umland)',
  },
  disposalMunchenLanding: {
    metaTitle: 'Clearance & Disposal München | RegionalUmzug24 – Compare Disposal companies',
    metaDescription:
      'Find vetted disposal companies in München. Compare free quotes from verified München providers with experience for Maxvorstadt, Schwabing and Munich outskirts.',
    metaKeywords: 'Clearance & Disposal München, disposal company München, disposal costs München',
    heroTitleStart: 'Your disposal in',
    heroTitleHighlight: 'München.',
    heroSubtitle:
      'Compare vetted Munich disposal companies for free – fast, discreet and experienced with Maxvorstadt, Schwabing and Munich outskirts.',
    heroCtaPrimary: 'Get Free Quotes',
    heroCtaSecondary: 'View München Companies',
    heroStatFirms: '110+ Munich companies',
    heroStatMoves: '230+ matched jobs',
    heroStatRating: '4.7/5 rating',
    benefitsTitle: 'Your benefits with RegionalUmzug24 for disposal in München',
    benefitsSubtitle: 'Why Munich customers choose our matching platform',
    benefitFreeTitle: '100% free of charge',
    benefitFreeDesc:
      'Submitting a request and comparing quotes is completely free and non-binding.',
    benefitVettedTitle: 'Vetted Disposal Specialists',
    benefitVettedDesc:
      'We match only vetted Munich disposal companies with insurance and certification.',
    benefitFastTitle: 'Fast Appointments',
    benefitFastDesc:
      'Receive quotes within 24 hours and book your preferred date – even short notice.',
    servicesTitle: 'Our disposal services in München',
    servicesSubtitle: 'What kind of disposal do you need in München?',
    serviceApartmentTitle: 'Apartment Clearance',
    serviceApartmentDesc:
      'Complete or partial clearance of your apartment in München including proper disposal.',
    serviceSecondaryTitle: 'House Clearance',
    serviceSecondaryDesc:
      'Full household clearance in München – sensitive, discreet and with disposal certificate.',
    serviceThirdTitle: 'Basement & Attic Clearance',
    serviceThirdDesc:
      'Finally space in your basement and attic in München – including bulky and hazardous waste collection.',
    serviceFourthTitle: 'Garden Clearance',
    serviceFourthDesc:
      'Removal of garden waste, old furniture and debris in München – including transport.',
    processTitle: 'How your disposal in München works',
    processSubtitle: 'In three simple steps to the right disposal company in München',
    step1Title: 'Submit a request',
    step1Desc: 'Describe your disposal need in München in just a few steps online.',
    step2Title: 'Receive Munich quotes',
    step2Desc: 'Suitable disposal companies from München send you their offers.',
    step3Title: 'Choose a company',
    step3Desc: 'Compare ratings and pick the best disposal offer in München.',
    statsTitle: 'Disposal in München by the numbers',
    statsSubtitle: 'Munich customers trust RegionalUmzug24',
    statFirms: '110+',
    statFirmsLabel: 'Munich disposal companies',
    statJobs: '230+',
    statJobsLabel: 'Matched jobs',
    statRating: '4.7/5',
    statRatingLabel: 'Customer rating',
    trustTitle: 'Vetted Munich disposal companies',
    trustSubtitle: 'Safety and quality – tailored to München',
    trustVerifiedTitle: 'Verified Munich companies',
    trustVerifiedDesc:
      'Every company is checked for business registration, insurance and disposal experience.',
    trustGdprTitle: 'GDPR compliant',
    trustGdprDesc: 'Your data is transmitted securely and never shared with third parties.',
    trustFreeTitle: '100% free',
    trustFreeDesc: 'Using RegionalUmzug24 is completely free for you – no hidden fees.',
    faqTitle: 'Frequently asked questions about disposal in München',
    faqSubtitle: 'Answers to the most common questions about disposal in München',
    faq1Question: 'How much does clearance in München cost?',
    faq1Answer:
      'The cost depends on volume, floor and disposal type. Through us you will receive free comparable quotes from München.',
    faq2Question: 'Is the waste properly disposed of in München?',
    faq2Answer:
      'Yes, all matched {cityAdjEn} companies dispose of waste properly with certificate. Recyclables are recycled, residual waste is properly disposed of.',
    faq3Question: 'How fast can clearance in München happen?',
    faq3Answer:
      'Usually you will receive the first quotes within 24 hours. Many {cityAdjEn} companies offer appointments within a few days.',
    faq4Question: 'Can I have only individual rooms cleared in München?',
    faq4Answer:
      'Yes, you can limit the request to individual rooms, basements or attics in München – the companies will create a suitable quote.',
    faq5Question: 'What happens to reusable items in München?',
    faq5Answer:
      'Valuable or reusable items can be sorted out in advance. Discuss details directly with the chosen {cityAdjEn} company.',
    ctaTitle: 'Ready for your disposal in München?',
    ctaSubtitle:
      'Create your free request now and receive quotes from vetted München disposal companies.',
    ctaPrimary: 'Create Request Now',
    ctaSecondary: 'View München Companies',
  },
  disposalMunchenDirectory: {
    metaTitle: 'Disposal Companies München | RegionalUmzug24 – Compare Munich Firms',
    metaDescription:
      'List of vetted disposal companies in München. Compare ratings, specialties and prices of Munich providers in postal code area 80-81.',
    metaKeywords: 'disposal companies München, Munich disposal company, disposal München firms',
    pageTitle: 'Disposal Companies in München',
    pageSubtitle:
      'Discover vetted Munich disposal companies with real reviews. Postal code area 80-81 – tailored to München.',
    filterTitle: 'Filters',
    filterPremium: 'Premium companies only',
    filterVerified: 'Verified companies only',
    filterPostalTitle: 'Postal code area',
    filterPostalAll: 'All postal code areas',
    sortTitle: 'Sort by',
    sortRating: 'Best rating',
    sortOrders: 'Most orders',
    sortNewest: 'Newest',
    resultCount: '{{count}} companies found',
    emptyTitle: 'No companies found',
    emptyDescription:
      'No Munich disposal companies match the current filters. Try adjusting the filters.',
    emptyReset: 'Reset filters',
    loadingTitle: 'Loading Munich disposal companies...',
    errorTitle: 'Error loading',
    errorDescription:
      'The list of Munich disposal companies could not be loaded. Please try again.',
    errorRetry: 'Retry',
    paginationPrev: 'Previous',
    paginationNext: 'Next',
    paginationPage: 'Page {{page}} of {{total}}',
    filterPostal80: 'PLZ 80 (Innenstadt)',
    filterPostal81: 'PLZ 81 (Umland)',
  },
  cleaningKolnLanding: {
    metaTitle: 'Cleaning Köln | RegionalUmzug24 – Compare Cleaning companies',
    metaDescription:
      'Find vetted cleaning companies in Köln. Compare free quotes from verified Köln providers with experience for cathedral, Südstadt and Rheinauhafen.',
    metaKeywords: 'Cleaning Köln, cleaning company Köln, cleaning costs Köln',
    heroTitleStart: 'Your cleaning in',
    heroTitleHighlight: 'Köln.',
    heroSubtitle:
      'Compare vetted Cologne cleaning companies for free – fast, discreet and experienced with cathedral, Südstadt and Rheinauhafen.',
    heroCtaPrimary: 'Get Free Quotes',
    heroCtaSecondary: 'View Köln Companies',
    heroStatFirms: '140+ Cologne companies',
    heroStatMoves: '280+ matched jobs',
    heroStatRating: '4.8/5 rating',
    benefitsTitle: 'Your benefits with RegionalUmzug24 for cleaning in Köln',
    benefitsSubtitle: 'Why Cologne customers choose our matching platform',
    benefitFreeTitle: '100% free of charge',
    benefitFreeDesc:
      'Submitting a request and comparing quotes is completely free and non-binding.',
    benefitVettedTitle: 'Vetted Cleaning Pros',
    benefitVettedDesc:
      'We match only vetted Cologne cleaning companies with insurance and certification.',
    benefitFastTitle: 'Fast Appointments',
    benefitFastDesc:
      'Receive quotes within 24 hours and book your preferred date – even short notice.',
    servicesTitle: 'Our cleaning services in Köln',
    servicesSubtitle: 'What kind of cleaning do you need in Köln?',
    serviceApartmentTitle: 'Apartment Cleaning',
    serviceApartmentDesc:
      'Thorough cleaning of your apartment – perfect before or after a move in Köln.',
    serviceSecondaryTitle: 'Office Cleaning',
    serviceSecondaryDesc:
      'Regular or one-off professional cleaning of your office or practice in Köln.',
    serviceThirdTitle: 'Move-Out Cleaning',
    serviceThirdDesc:
      'Broom-clean handover of your Köln apartment including acceptance guarantee with the landlord.',
    serviceFourthTitle: 'Window Cleaning',
    serviceFourthDesc:
      'Streak-free windows, frames and sills in Köln – including hard-to-reach heights.',
    processTitle: 'How your cleaning in Köln works',
    processSubtitle: 'In three simple steps to the right cleaning company in Köln',
    step1Title: 'Submit a request',
    step1Desc: 'Describe your cleaning need in Köln in just a few steps online.',
    step2Title: 'Receive Cologne quotes',
    step2Desc: 'Suitable cleaning companies from Köln send you their offers.',
    step3Title: 'Choose a company',
    step3Desc: 'Compare ratings and pick the best cleaning offer in Köln.',
    statsTitle: 'Cleaning in Köln by the numbers',
    statsSubtitle: 'Cologne customers trust RegionalUmzug24',
    statFirms: '140+',
    statFirmsLabel: 'Cologne cleaning companies',
    statJobs: '280+',
    statJobsLabel: 'Matched jobs',
    statRating: '4.8/5',
    statRatingLabel: 'Customer rating',
    trustTitle: 'Vetted Cologne cleaning companies',
    trustSubtitle: 'Safety and quality – tailored to Köln',
    trustVerifiedTitle: 'Verified Cologne companies',
    trustVerifiedDesc:
      'Every company is checked for business registration, insurance and cleaning experience.',
    trustGdprTitle: 'GDPR compliant',
    trustGdprDesc: 'Your data is transmitted securely and never shared with third parties.',
    trustFreeTitle: '100% free',
    trustFreeDesc: 'Using RegionalUmzug24 is completely free for you – no hidden fees.',
    faqTitle: 'Frequently asked questions about cleaning in Köln',
    faqSubtitle: 'Answers to the most common questions about cleaning in Köln',
    faq1Question: 'How much does cleaning in Köln cost?',
    faq1Answer:
      'The cost depends on size, condition and type of cleaning. Through us you will receive free comparable quotes from Köln.',
    faq2Question: 'Are cleaning companies in Köln insured?',
    faq2Answer:
      'Yes, all matched {cityAdjEn} cleaning companies are vetted and have liability insurance. You are covered in case of damage.',
    faq3Question: 'How fast will I receive Köln quotes?',
    faq3Answer:
      'Usually you will receive the first quotes from suitable cleaning companies in Köln and surroundings within 24 hours.',
    faq4Question: 'Can I book a short-notice cleaning in Köln?',
    faq4Answer:
      'Yes, many cleaning companies in Köln also offer short-notice appointments. Simply enter your preferred date in the request.',
    faq5Question: 'Which cleaning services are offered in Köln?',
    faq5Answer:
      'From apartment cleaning to office, window and carpet cleaning – the matched companies cover the full spectrum.',
    ctaTitle: 'Ready for your cleaning in Köln?',
    ctaSubtitle:
      'Create your free request now and receive quotes from vetted Köln cleaning companies.',
    ctaPrimary: 'Create Request Now',
    ctaSecondary: 'View Köln Companies',
  },
  cleaningKolnDirectory: {
    metaTitle: 'Cleaning Companies Köln | RegionalUmzug24 – Compare Cologne Firms',
    metaDescription:
      'List of vetted cleaning companies in Köln. Compare ratings, specialties and prices of Cologne providers in postal code area 50-51.',
    metaKeywords: 'cleaning companies Köln, Cologne cleaning company, cleaning Köln firms',
    pageTitle: 'Cleaning Companies in Köln',
    pageSubtitle:
      'Discover vetted Cologne cleaning companies with real reviews. Postal code area 50-51 – tailored to Köln.',
    filterTitle: 'Filters',
    filterPremium: 'Premium companies only',
    filterVerified: 'Verified companies only',
    filterPostalTitle: 'Postal code area',
    filterPostalAll: 'All postal code areas',
    sortTitle: 'Sort by',
    sortRating: 'Best rating',
    sortOrders: 'Most orders',
    sortNewest: 'Newest',
    resultCount: '{{count}} companies found',
    emptyTitle: 'No companies found',
    emptyDescription:
      'No Cologne cleaning companies match the current filters. Try adjusting the filters.',
    emptyReset: 'Reset filters',
    loadingTitle: 'Loading Cologne cleaning companies...',
    errorTitle: 'Error loading',
    errorDescription:
      'The list of Cologne cleaning companies could not be loaded. Please try again.',
    errorRetry: 'Retry',
    paginationPrev: 'Previous',
    paginationNext: 'Next',
    paginationPage: 'Page {{page}} of {{total}}',
    filterPostal50: 'PLZ 50 (Innenstadt)',
    filterPostal51: 'PLZ 51 (rechtsrheinisch)',
  },
  disposalKolnLanding: {
    metaTitle: 'Clearance & Disposal Köln | RegionalUmzug24 – Compare Disposal companies',
    metaDescription:
      'Find vetted disposal companies in Köln. Compare free quotes from verified Köln providers with experience for cathedral, Südstadt and Rheinauhafen.',
    metaKeywords: 'Clearance & Disposal Köln, disposal company Köln, disposal costs Köln',
    heroTitleStart: 'Your disposal in',
    heroTitleHighlight: 'Köln.',
    heroSubtitle:
      'Compare vetted Cologne disposal companies for free – fast, discreet and experienced with cathedral, Südstadt and Rheinauhafen.',
    heroCtaPrimary: 'Get Free Quotes',
    heroCtaSecondary: 'View Köln Companies',
    heroStatFirms: '110+ Cologne companies',
    heroStatMoves: '230+ matched jobs',
    heroStatRating: '4.7/5 rating',
    benefitsTitle: 'Your benefits with RegionalUmzug24 for disposal in Köln',
    benefitsSubtitle: 'Why Cologne customers choose our matching platform',
    benefitFreeTitle: '100% free of charge',
    benefitFreeDesc:
      'Submitting a request and comparing quotes is completely free and non-binding.',
    benefitVettedTitle: 'Vetted Disposal Specialists',
    benefitVettedDesc:
      'We match only vetted Cologne disposal companies with insurance and certification.',
    benefitFastTitle: 'Fast Appointments',
    benefitFastDesc:
      'Receive quotes within 24 hours and book your preferred date – even short notice.',
    servicesTitle: 'Our disposal services in Köln',
    servicesSubtitle: 'What kind of disposal do you need in Köln?',
    serviceApartmentTitle: 'Apartment Clearance',
    serviceApartmentDesc:
      'Complete or partial clearance of your apartment in Köln including proper disposal.',
    serviceSecondaryTitle: 'House Clearance',
    serviceSecondaryDesc:
      'Full household clearance in Köln – sensitive, discreet and with disposal certificate.',
    serviceThirdTitle: 'Basement & Attic Clearance',
    serviceThirdDesc:
      'Finally space in your basement and attic in Köln – including bulky and hazardous waste collection.',
    serviceFourthTitle: 'Garden Clearance',
    serviceFourthDesc:
      'Removal of garden waste, old furniture and debris in Köln – including transport.',
    processTitle: 'How your disposal in Köln works',
    processSubtitle: 'In three simple steps to the right disposal company in Köln',
    step1Title: 'Submit a request',
    step1Desc: 'Describe your disposal need in Köln in just a few steps online.',
    step2Title: 'Receive Cologne quotes',
    step2Desc: 'Suitable disposal companies from Köln send you their offers.',
    step3Title: 'Choose a company',
    step3Desc: 'Compare ratings and pick the best disposal offer in Köln.',
    statsTitle: 'Disposal in Köln by the numbers',
    statsSubtitle: 'Cologne customers trust RegionalUmzug24',
    statFirms: '110+',
    statFirmsLabel: 'Cologne disposal companies',
    statJobs: '230+',
    statJobsLabel: 'Matched jobs',
    statRating: '4.7/5',
    statRatingLabel: 'Customer rating',
    trustTitle: 'Vetted Cologne disposal companies',
    trustSubtitle: 'Safety and quality – tailored to Köln',
    trustVerifiedTitle: 'Verified Cologne companies',
    trustVerifiedDesc:
      'Every company is checked for business registration, insurance and disposal experience.',
    trustGdprTitle: 'GDPR compliant',
    trustGdprDesc: 'Your data is transmitted securely and never shared with third parties.',
    trustFreeTitle: '100% free',
    trustFreeDesc: 'Using RegionalUmzug24 is completely free for you – no hidden fees.',
    faqTitle: 'Frequently asked questions about disposal in Köln',
    faqSubtitle: 'Answers to the most common questions about disposal in Köln',
    faq1Question: 'How much does clearance in Köln cost?',
    faq1Answer:
      'The cost depends on volume, floor and disposal type. Through us you will receive free comparable quotes from Köln.',
    faq2Question: 'Is the waste properly disposed of in Köln?',
    faq2Answer:
      'Yes, all matched {cityAdjEn} companies dispose of waste properly with certificate. Recyclables are recycled, residual waste is properly disposed of.',
    faq3Question: 'How fast can clearance in Köln happen?',
    faq3Answer:
      'Usually you will receive the first quotes within 24 hours. Many {cityAdjEn} companies offer appointments within a few days.',
    faq4Question: 'Can I have only individual rooms cleared in Köln?',
    faq4Answer:
      'Yes, you can limit the request to individual rooms, basements or attics in Köln – the companies will create a suitable quote.',
    faq5Question: 'What happens to reusable items in Köln?',
    faq5Answer:
      'Valuable or reusable items can be sorted out in advance. Discuss details directly with the chosen {cityAdjEn} company.',
    ctaTitle: 'Ready for your disposal in Köln?',
    ctaSubtitle:
      'Create your free request now and receive quotes from vetted Köln disposal companies.',
    ctaPrimary: 'Create Request Now',
    ctaSecondary: 'View Köln Companies',
  },
  disposalKolnDirectory: {
    metaTitle: 'Disposal Companies Köln | RegionalUmzug24 – Compare Cologne Firms',
    metaDescription:
      'List of vetted disposal companies in Köln. Compare ratings, specialties and prices of Cologne providers in postal code area 50-51.',
    metaKeywords: 'disposal companies Köln, Cologne disposal company, disposal Köln firms',
    pageTitle: 'Disposal Companies in Köln',
    pageSubtitle:
      'Discover vetted Cologne disposal companies with real reviews. Postal code area 50-51 – tailored to Köln.',
    filterTitle: 'Filters',
    filterPremium: 'Premium companies only',
    filterVerified: 'Verified companies only',
    filterPostalTitle: 'Postal code area',
    filterPostalAll: 'All postal code areas',
    sortTitle: 'Sort by',
    sortRating: 'Best rating',
    sortOrders: 'Most orders',
    sortNewest: 'Newest',
    resultCount: '{{count}} companies found',
    emptyTitle: 'No companies found',
    emptyDescription:
      'No Cologne disposal companies match the current filters. Try adjusting the filters.',
    emptyReset: 'Reset filters',
    loadingTitle: 'Loading Cologne disposal companies...',
    errorTitle: 'Error loading',
    errorDescription:
      'The list of Cologne disposal companies could not be loaded. Please try again.',
    errorRetry: 'Retry',
    paginationPrev: 'Previous',
    paginationNext: 'Next',
    paginationPage: 'Page {{page}} of {{total}}',
    filterPostal50: 'PLZ 50 (Innenstadt)',
    filterPostal51: 'PLZ 51 (rechtsrheinisch)',
  },
  cleaningFrankfurtamMainLanding: {
    metaTitle: 'Cleaning Frankfurt am Main | RegionalUmzug24 – Compare Cleaning companies',
    metaDescription:
      'Find vetted cleaning companies in Frankfurt am Main. Compare free quotes from verified Frankfurt am Main providers with experience for Westend, banking district and Sachsenhausen.',
    metaKeywords:
      'Cleaning Frankfurt am Main, cleaning company Frankfurt am Main, cleaning costs Frankfurt am Main',
    heroTitleStart: 'Your cleaning in',
    heroTitleHighlight: 'Frankfurt am Main.',
    heroSubtitle:
      'Compare vetted Frankfurt cleaning companies for free – fast, discreet and experienced with Westend, banking district and Sachsenhausen.',
    heroCtaPrimary: 'Get Free Quotes',
    heroCtaSecondary: 'View Frankfurt am Main Companies',
    heroStatFirms: '140+ Frankfurt companies',
    heroStatMoves: '280+ matched jobs',
    heroStatRating: '4.8/5 rating',
    benefitsTitle: 'Your benefits with RegionalUmzug24 for cleaning in Frankfurt am Main',
    benefitsSubtitle: 'Why Frankfurt customers choose our matching platform',
    benefitFreeTitle: '100% free of charge',
    benefitFreeDesc:
      'Submitting a request and comparing quotes is completely free and non-binding.',
    benefitVettedTitle: 'Vetted Cleaning Pros',
    benefitVettedDesc:
      'We match only vetted Frankfurt cleaning companies with insurance and certification.',
    benefitFastTitle: 'Fast Appointments',
    benefitFastDesc:
      'Receive quotes within 24 hours and book your preferred date – even short notice.',
    servicesTitle: 'Our cleaning services in Frankfurt am Main',
    servicesSubtitle: 'What kind of cleaning do you need in Frankfurt am Main?',
    serviceApartmentTitle: 'Apartment Cleaning',
    serviceApartmentDesc:
      'Thorough cleaning of your apartment – perfect before or after a move in Frankfurt am Main.',
    serviceSecondaryTitle: 'Office Cleaning',
    serviceSecondaryDesc:
      'Regular or one-off professional cleaning of your office or practice in Frankfurt am Main.',
    serviceThirdTitle: 'Move-Out Cleaning',
    serviceThirdDesc:
      'Broom-clean handover of your Frankfurt am Main apartment including acceptance guarantee with the landlord.',
    serviceFourthTitle: 'Window Cleaning',
    serviceFourthDesc:
      'Streak-free windows, frames and sills in Frankfurt am Main – including hard-to-reach heights.',
    processTitle: 'How your cleaning in Frankfurt am Main works',
    processSubtitle: 'In three simple steps to the right cleaning company in Frankfurt am Main',
    step1Title: 'Submit a request',
    step1Desc: 'Describe your cleaning need in Frankfurt am Main in just a few steps online.',
    step2Title: 'Receive Frankfurt quotes',
    step2Desc: 'Suitable cleaning companies from Frankfurt am Main send you their offers.',
    step3Title: 'Choose a company',
    step3Desc: 'Compare ratings and pick the best cleaning offer in Frankfurt am Main.',
    statsTitle: 'Cleaning in Frankfurt am Main by the numbers',
    statsSubtitle: 'Frankfurt customers trust RegionalUmzug24',
    statFirms: '140+',
    statFirmsLabel: 'Frankfurt cleaning companies',
    statJobs: '280+',
    statJobsLabel: 'Matched jobs',
    statRating: '4.8/5',
    statRatingLabel: 'Customer rating',
    trustTitle: 'Vetted Frankfurt cleaning companies',
    trustSubtitle: 'Safety and quality – tailored to Frankfurt am Main',
    trustVerifiedTitle: 'Verified Frankfurt companies',
    trustVerifiedDesc:
      'Every company is checked for business registration, insurance and cleaning experience.',
    trustGdprTitle: 'GDPR compliant',
    trustGdprDesc: 'Your data is transmitted securely and never shared with third parties.',
    trustFreeTitle: '100% free',
    trustFreeDesc: 'Using RegionalUmzug24 is completely free for you – no hidden fees.',
    faqTitle: 'Frequently asked questions about cleaning in Frankfurt am Main',
    faqSubtitle: 'Answers to the most common questions about cleaning in Frankfurt am Main',
    faq1Question: 'How much does cleaning in Frankfurt am Main cost?',
    faq1Answer:
      'The cost depends on size, condition and type of cleaning. Through us you will receive free comparable quotes from Frankfurt am Main.',
    faq2Question: 'Are cleaning companies in Frankfurt am Main insured?',
    faq2Answer:
      'Yes, all matched {cityAdjEn} cleaning companies are vetted and have liability insurance. You are covered in case of damage.',
    faq3Question: 'How fast will I receive Frankfurt am Main quotes?',
    faq3Answer:
      'Usually you will receive the first quotes from suitable cleaning companies in Frankfurt am Main and surroundings within 24 hours.',
    faq4Question: 'Can I book a short-notice cleaning in Frankfurt am Main?',
    faq4Answer:
      'Yes, many cleaning companies in Frankfurt am Main also offer short-notice appointments. Simply enter your preferred date in the request.',
    faq5Question: 'Which cleaning services are offered in Frankfurt am Main?',
    faq5Answer:
      'From apartment cleaning to office, window and carpet cleaning – the matched companies cover the full spectrum.',
    ctaTitle: 'Ready for your cleaning in Frankfurt am Main?',
    ctaSubtitle:
      'Create your free request now and receive quotes from vetted Frankfurt am Main cleaning companies.',
    ctaPrimary: 'Create Request Now',
    ctaSecondary: 'View Frankfurt am Main Companies',
  },
  cleaningFrankfurtamMainDirectory: {
    metaTitle: 'Cleaning Companies Frankfurt am Main | RegionalUmzug24 – Compare Frankfurt Firms',
    metaDescription:
      'List of vetted cleaning companies in Frankfurt am Main. Compare ratings, specialties and prices of Frankfurt providers in postal code area 60-65.',
    metaKeywords:
      'cleaning companies Frankfurt am Main, Frankfurt cleaning company, cleaning Frankfurt am Main firms',
    pageTitle: 'Cleaning Companies in Frankfurt am Main',
    pageSubtitle:
      'Discover vetted Frankfurt cleaning companies with real reviews. Postal code area 60-65 – tailored to Frankfurt am Main.',
    filterTitle: 'Filters',
    filterPremium: 'Premium companies only',
    filterVerified: 'Verified companies only',
    filterPostalTitle: 'Postal code area',
    filterPostalAll: 'All postal code areas',
    sortTitle: 'Sort by',
    sortRating: 'Best rating',
    sortOrders: 'Most orders',
    sortNewest: 'Newest',
    resultCount: '{{count}} companies found',
    emptyTitle: 'No companies found',
    emptyDescription:
      'No Frankfurt cleaning companies match the current filters. Try adjusting the filters.',
    emptyReset: 'Reset filters',
    loadingTitle: 'Loading Frankfurt cleaning companies...',
    errorTitle: 'Error loading',
    errorDescription:
      'The list of Frankfurt cleaning companies could not be loaded. Please try again.',
    errorRetry: 'Retry',
    paginationPrev: 'Previous',
    paginationNext: 'Next',
    paginationPage: 'Page {{page}} of {{total}}',
    filterPostal60: 'PLZ 60 (Westend)',
    filterPostal65: 'PLZ 65 (Höchst)',
  },
  disposalFrankfurtamMainLanding: {
    metaTitle:
      'Clearance & Disposal Frankfurt am Main | RegionalUmzug24 – Compare Disposal companies',
    metaDescription:
      'Find vetted disposal companies in Frankfurt am Main. Compare free quotes from verified Frankfurt am Main providers with experience for Westend, banking district and Sachsenhausen.',
    metaKeywords:
      'Clearance & Disposal Frankfurt am Main, disposal company Frankfurt am Main, disposal costs Frankfurt am Main',
    heroTitleStart: 'Your disposal in',
    heroTitleHighlight: 'Frankfurt am Main.',
    heroSubtitle:
      'Compare vetted Frankfurt disposal companies for free – fast, discreet and experienced with Westend, banking district and Sachsenhausen.',
    heroCtaPrimary: 'Get Free Quotes',
    heroCtaSecondary: 'View Frankfurt am Main Companies',
    heroStatFirms: '110+ Frankfurt companies',
    heroStatMoves: '230+ matched jobs',
    heroStatRating: '4.7/5 rating',
    benefitsTitle: 'Your benefits with RegionalUmzug24 for disposal in Frankfurt am Main',
    benefitsSubtitle: 'Why Frankfurt customers choose our matching platform',
    benefitFreeTitle: '100% free of charge',
    benefitFreeDesc:
      'Submitting a request and comparing quotes is completely free and non-binding.',
    benefitVettedTitle: 'Vetted Disposal Specialists',
    benefitVettedDesc:
      'We match only vetted Frankfurt disposal companies with insurance and certification.',
    benefitFastTitle: 'Fast Appointments',
    benefitFastDesc:
      'Receive quotes within 24 hours and book your preferred date – even short notice.',
    servicesTitle: 'Our disposal services in Frankfurt am Main',
    servicesSubtitle: 'What kind of disposal do you need in Frankfurt am Main?',
    serviceApartmentTitle: 'Apartment Clearance',
    serviceApartmentDesc:
      'Complete or partial clearance of your apartment in Frankfurt am Main including proper disposal.',
    serviceSecondaryTitle: 'House Clearance',
    serviceSecondaryDesc:
      'Full household clearance in Frankfurt am Main – sensitive, discreet and with disposal certificate.',
    serviceThirdTitle: 'Basement & Attic Clearance',
    serviceThirdDesc:
      'Finally space in your basement and attic in Frankfurt am Main – including bulky and hazardous waste collection.',
    serviceFourthTitle: 'Garden Clearance',
    serviceFourthDesc:
      'Removal of garden waste, old furniture and debris in Frankfurt am Main – including transport.',
    processTitle: 'How your disposal in Frankfurt am Main works',
    processSubtitle: 'In three simple steps to the right disposal company in Frankfurt am Main',
    step1Title: 'Submit a request',
    step1Desc: 'Describe your disposal need in Frankfurt am Main in just a few steps online.',
    step2Title: 'Receive Frankfurt quotes',
    step2Desc: 'Suitable disposal companies from Frankfurt am Main send you their offers.',
    step3Title: 'Choose a company',
    step3Desc: 'Compare ratings and pick the best disposal offer in Frankfurt am Main.',
    statsTitle: 'Disposal in Frankfurt am Main by the numbers',
    statsSubtitle: 'Frankfurt customers trust RegionalUmzug24',
    statFirms: '110+',
    statFirmsLabel: 'Frankfurt disposal companies',
    statJobs: '230+',
    statJobsLabel: 'Matched jobs',
    statRating: '4.7/5',
    statRatingLabel: 'Customer rating',
    trustTitle: 'Vetted Frankfurt disposal companies',
    trustSubtitle: 'Safety and quality – tailored to Frankfurt am Main',
    trustVerifiedTitle: 'Verified Frankfurt companies',
    trustVerifiedDesc:
      'Every company is checked for business registration, insurance and disposal experience.',
    trustGdprTitle: 'GDPR compliant',
    trustGdprDesc: 'Your data is transmitted securely and never shared with third parties.',
    trustFreeTitle: '100% free',
    trustFreeDesc: 'Using RegionalUmzug24 is completely free for you – no hidden fees.',
    faqTitle: 'Frequently asked questions about disposal in Frankfurt am Main',
    faqSubtitle: 'Answers to the most common questions about disposal in Frankfurt am Main',
    faq1Question: 'How much does clearance in Frankfurt am Main cost?',
    faq1Answer:
      'The cost depends on volume, floor and disposal type. Through us you will receive free comparable quotes from Frankfurt am Main.',
    faq2Question: 'Is the waste properly disposed of in Frankfurt am Main?',
    faq2Answer:
      'Yes, all matched {cityAdjEn} companies dispose of waste properly with certificate. Recyclables are recycled, residual waste is properly disposed of.',
    faq3Question: 'How fast can clearance in Frankfurt am Main happen?',
    faq3Answer:
      'Usually you will receive the first quotes within 24 hours. Many {cityAdjEn} companies offer appointments within a few days.',
    faq4Question: 'Can I have only individual rooms cleared in Frankfurt am Main?',
    faq4Answer:
      'Yes, you can limit the request to individual rooms, basements or attics in Frankfurt am Main – the companies will create a suitable quote.',
    faq5Question: 'What happens to reusable items in Frankfurt am Main?',
    faq5Answer:
      'Valuable or reusable items can be sorted out in advance. Discuss details directly with the chosen {cityAdjEn} company.',
    ctaTitle: 'Ready for your disposal in Frankfurt am Main?',
    ctaSubtitle:
      'Create your free request now and receive quotes from vetted Frankfurt am Main disposal companies.',
    ctaPrimary: 'Create Request Now',
    ctaSecondary: 'View Frankfurt am Main Companies',
  },
  disposalFrankfurtamMainDirectory: {
    metaTitle: 'Disposal Companies Frankfurt am Main | RegionalUmzug24 – Compare Frankfurt Firms',
    metaDescription:
      'List of vetted disposal companies in Frankfurt am Main. Compare ratings, specialties and prices of Frankfurt providers in postal code area 60-65.',
    metaKeywords:
      'disposal companies Frankfurt am Main, Frankfurt disposal company, disposal Frankfurt am Main firms',
    pageTitle: 'Disposal Companies in Frankfurt am Main',
    pageSubtitle:
      'Discover vetted Frankfurt disposal companies with real reviews. Postal code area 60-65 – tailored to Frankfurt am Main.',
    filterTitle: 'Filters',
    filterPremium: 'Premium companies only',
    filterVerified: 'Verified companies only',
    filterPostalTitle: 'Postal code area',
    filterPostalAll: 'All postal code areas',
    sortTitle: 'Sort by',
    sortRating: 'Best rating',
    sortOrders: 'Most orders',
    sortNewest: 'Newest',
    resultCount: '{{count}} companies found',
    emptyTitle: 'No companies found',
    emptyDescription:
      'No Frankfurt disposal companies match the current filters. Try adjusting the filters.',
    emptyReset: 'Reset filters',
    loadingTitle: 'Loading Frankfurt disposal companies...',
    errorTitle: 'Error loading',
    errorDescription:
      'The list of Frankfurt disposal companies could not be loaded. Please try again.',
    errorRetry: 'Retry',
    paginationPrev: 'Previous',
    paginationNext: 'Next',
    paginationPage: 'Page {{page}} of {{total}}',
    filterPostal60: 'PLZ 60 (Westend)',
    filterPostal65: 'PLZ 65 (Höchst)',
  },
  cleaningStuttgartLanding: {
    metaTitle: 'Cleaning Stuttgart | RegionalUmzug24 – Compare Cleaning companies',
    metaDescription:
      'Find vetted cleaning companies in Stuttgart. Compare free quotes from verified Stuttgart providers with experience for the basin, the Filder plain and Swabia.',
    metaKeywords: 'Cleaning Stuttgart, cleaning company Stuttgart, cleaning costs Stuttgart',
    heroTitleStart: 'Your cleaning in',
    heroTitleHighlight: 'Stuttgart.',
    heroSubtitle:
      'Compare vetted Stuttgart cleaning companies for free – fast, discreet and experienced with the basin, the Filder plain and Swabia.',
    heroCtaPrimary: 'Get Free Quotes',
    heroCtaSecondary: 'View Stuttgart Companies',
    heroStatFirms: '140+ Stuttgart companies',
    heroStatMoves: '280+ matched jobs',
    heroStatRating: '4.8/5 rating',
    benefitsTitle: 'Your benefits with RegionalUmzug24 for cleaning in Stuttgart',
    benefitsSubtitle: 'Why Stuttgart customers choose our matching platform',
    benefitFreeTitle: '100% free of charge',
    benefitFreeDesc:
      'Submitting a request and comparing quotes is completely free and non-binding.',
    benefitVettedTitle: 'Vetted Cleaning Pros',
    benefitVettedDesc:
      'We match only vetted Stuttgart cleaning companies with insurance and certification.',
    benefitFastTitle: 'Fast Appointments',
    benefitFastDesc:
      'Receive quotes within 24 hours and book your preferred date – even short notice.',
    servicesTitle: 'Our cleaning services in Stuttgart',
    servicesSubtitle: 'What kind of cleaning do you need in Stuttgart?',
    serviceApartmentTitle: 'Apartment Cleaning',
    serviceApartmentDesc:
      'Thorough cleaning of your apartment – perfect before or after a move in Stuttgart.',
    serviceSecondaryTitle: 'Office Cleaning',
    serviceSecondaryDesc:
      'Regular or one-off professional cleaning of your office or practice in Stuttgart.',
    serviceThirdTitle: 'Move-Out Cleaning',
    serviceThirdDesc:
      'Broom-clean handover of your Stuttgart apartment including acceptance guarantee with the landlord.',
    serviceFourthTitle: 'Window Cleaning',
    serviceFourthDesc:
      'Streak-free windows, frames and sills in Stuttgart – including hard-to-reach heights.',
    processTitle: 'How your cleaning in Stuttgart works',
    processSubtitle: 'In three simple steps to the right cleaning company in Stuttgart',
    step1Title: 'Submit a request',
    step1Desc: 'Describe your cleaning need in Stuttgart in just a few steps online.',
    step2Title: 'Receive Stuttgart quotes',
    step2Desc: 'Suitable cleaning companies from Stuttgart send you their offers.',
    step3Title: 'Choose a company',
    step3Desc: 'Compare ratings and pick the best cleaning offer in Stuttgart.',
    statsTitle: 'Cleaning in Stuttgart by the numbers',
    statsSubtitle: 'Stuttgart customers trust RegionalUmzug24',
    statFirms: '140+',
    statFirmsLabel: 'Stuttgart cleaning companies',
    statJobs: '280+',
    statJobsLabel: 'Matched jobs',
    statRating: '4.8/5',
    statRatingLabel: 'Customer rating',
    trustTitle: 'Vetted Stuttgart cleaning companies',
    trustSubtitle: 'Safety and quality – tailored to Stuttgart',
    trustVerifiedTitle: 'Verified Stuttgart companies',
    trustVerifiedDesc:
      'Every company is checked for business registration, insurance and cleaning experience.',
    trustGdprTitle: 'GDPR compliant',
    trustGdprDesc: 'Your data is transmitted securely and never shared with third parties.',
    trustFreeTitle: '100% free',
    trustFreeDesc: 'Using RegionalUmzug24 is completely free for you – no hidden fees.',
    faqTitle: 'Frequently asked questions about cleaning in Stuttgart',
    faqSubtitle: 'Answers to the most common questions about cleaning in Stuttgart',
    faq1Question: 'How much does cleaning in Stuttgart cost?',
    faq1Answer:
      'The cost depends on size, condition and type of cleaning. Through us you will receive free comparable quotes from Stuttgart.',
    faq2Question: 'Are cleaning companies in Stuttgart insured?',
    faq2Answer:
      'Yes, all matched {cityAdjEn} cleaning companies are vetted and have liability insurance. You are covered in case of damage.',
    faq3Question: 'How fast will I receive Stuttgart quotes?',
    faq3Answer:
      'Usually you will receive the first quotes from suitable cleaning companies in Stuttgart and surroundings within 24 hours.',
    faq4Question: 'Can I book a short-notice cleaning in Stuttgart?',
    faq4Answer:
      'Yes, many cleaning companies in Stuttgart also offer short-notice appointments. Simply enter your preferred date in the request.',
    faq5Question: 'Which cleaning services are offered in Stuttgart?',
    faq5Answer:
      'From apartment cleaning to office, window and carpet cleaning – the matched companies cover the full spectrum.',
    ctaTitle: 'Ready for your cleaning in Stuttgart?',
    ctaSubtitle:
      'Create your free request now and receive quotes from vetted Stuttgart cleaning companies.',
    ctaPrimary: 'Create Request Now',
    ctaSecondary: 'View Stuttgart Companies',
  },
  cleaningStuttgartDirectory: {
    metaTitle: 'Cleaning Companies Stuttgart | RegionalUmzug24 – Compare Stuttgart Firms',
    metaDescription:
      'List of vetted cleaning companies in Stuttgart. Compare ratings, specialties and prices of Stuttgart providers in postal code area 70.',
    metaKeywords:
      'cleaning companies Stuttgart, Stuttgart cleaning company, cleaning Stuttgart firms',
    pageTitle: 'Cleaning Companies in Stuttgart',
    pageSubtitle:
      'Discover vetted Stuttgart cleaning companies with real reviews. Postal code area 70 – tailored to Stuttgart.',
    filterTitle: 'Filters',
    filterPremium: 'Premium companies only',
    filterVerified: 'Verified companies only',
    filterPostalTitle: 'Postal code area',
    filterPostalAll: 'All postal code areas',
    sortTitle: 'Sort by',
    sortRating: 'Best rating',
    sortOrders: 'Most orders',
    sortNewest: 'Newest',
    resultCount: '{{count}} companies found',
    emptyTitle: 'No companies found',
    emptyDescription:
      'No Stuttgart cleaning companies match the current filters. Try adjusting the filters.',
    emptyReset: 'Reset filters',
    loadingTitle: 'Loading Stuttgart cleaning companies...',
    errorTitle: 'Error loading',
    errorDescription:
      'The list of Stuttgart cleaning companies could not be loaded. Please try again.',
    errorRetry: 'Retry',
    paginationPrev: 'Previous',
    paginationNext: 'Next',
    paginationPage: 'Page {{page}} of {{total}}',
    filterPostal70: 'PLZ 70 (Talkessel)',
  },
  disposalStuttgartLanding: {
    metaTitle: 'Clearance & Disposal Stuttgart | RegionalUmzug24 – Compare Disposal companies',
    metaDescription:
      'Find vetted disposal companies in Stuttgart. Compare free quotes from verified Stuttgart providers with experience for the basin, the Filder plain and Swabia.',
    metaKeywords:
      'Clearance & Disposal Stuttgart, disposal company Stuttgart, disposal costs Stuttgart',
    heroTitleStart: 'Your disposal in',
    heroTitleHighlight: 'Stuttgart.',
    heroSubtitle:
      'Compare vetted Stuttgart disposal companies for free – fast, discreet and experienced with the basin, the Filder plain and Swabia.',
    heroCtaPrimary: 'Get Free Quotes',
    heroCtaSecondary: 'View Stuttgart Companies',
    heroStatFirms: '110+ Stuttgart companies',
    heroStatMoves: '230+ matched jobs',
    heroStatRating: '4.7/5 rating',
    benefitsTitle: 'Your benefits with RegionalUmzug24 for disposal in Stuttgart',
    benefitsSubtitle: 'Why Stuttgart customers choose our matching platform',
    benefitFreeTitle: '100% free of charge',
    benefitFreeDesc:
      'Submitting a request and comparing quotes is completely free and non-binding.',
    benefitVettedTitle: 'Vetted Disposal Specialists',
    benefitVettedDesc:
      'We match only vetted Stuttgart disposal companies with insurance and certification.',
    benefitFastTitle: 'Fast Appointments',
    benefitFastDesc:
      'Receive quotes within 24 hours and book your preferred date – even short notice.',
    servicesTitle: 'Our disposal services in Stuttgart',
    servicesSubtitle: 'What kind of disposal do you need in Stuttgart?',
    serviceApartmentTitle: 'Apartment Clearance',
    serviceApartmentDesc:
      'Complete or partial clearance of your apartment in Stuttgart including proper disposal.',
    serviceSecondaryTitle: 'House Clearance',
    serviceSecondaryDesc:
      'Full household clearance in Stuttgart – sensitive, discreet and with disposal certificate.',
    serviceThirdTitle: 'Basement & Attic Clearance',
    serviceThirdDesc:
      'Finally space in your basement and attic in Stuttgart – including bulky and hazardous waste collection.',
    serviceFourthTitle: 'Garden Clearance',
    serviceFourthDesc:
      'Removal of garden waste, old furniture and debris in Stuttgart – including transport.',
    processTitle: 'How your disposal in Stuttgart works',
    processSubtitle: 'In three simple steps to the right disposal company in Stuttgart',
    step1Title: 'Submit a request',
    step1Desc: 'Describe your disposal need in Stuttgart in just a few steps online.',
    step2Title: 'Receive Stuttgart quotes',
    step2Desc: 'Suitable disposal companies from Stuttgart send you their offers.',
    step3Title: 'Choose a company',
    step3Desc: 'Compare ratings and pick the best disposal offer in Stuttgart.',
    statsTitle: 'Disposal in Stuttgart by the numbers',
    statsSubtitle: 'Stuttgart customers trust RegionalUmzug24',
    statFirms: '110+',
    statFirmsLabel: 'Stuttgart disposal companies',
    statJobs: '230+',
    statJobsLabel: 'Matched jobs',
    statRating: '4.7/5',
    statRatingLabel: 'Customer rating',
    trustTitle: 'Vetted Stuttgart disposal companies',
    trustSubtitle: 'Safety and quality – tailored to Stuttgart',
    trustVerifiedTitle: 'Verified Stuttgart companies',
    trustVerifiedDesc:
      'Every company is checked for business registration, insurance and disposal experience.',
    trustGdprTitle: 'GDPR compliant',
    trustGdprDesc: 'Your data is transmitted securely and never shared with third parties.',
    trustFreeTitle: '100% free',
    trustFreeDesc: 'Using RegionalUmzug24 is completely free for you – no hidden fees.',
    faqTitle: 'Frequently asked questions about disposal in Stuttgart',
    faqSubtitle: 'Answers to the most common questions about disposal in Stuttgart',
    faq1Question: 'How much does clearance in Stuttgart cost?',
    faq1Answer:
      'The cost depends on volume, floor and disposal type. Through us you will receive free comparable quotes from Stuttgart.',
    faq2Question: 'Is the waste properly disposed of in Stuttgart?',
    faq2Answer:
      'Yes, all matched {cityAdjEn} companies dispose of waste properly with certificate. Recyclables are recycled, residual waste is properly disposed of.',
    faq3Question: 'How fast can clearance in Stuttgart happen?',
    faq3Answer:
      'Usually you will receive the first quotes within 24 hours. Many {cityAdjEn} companies offer appointments within a few days.',
    faq4Question: 'Can I have only individual rooms cleared in Stuttgart?',
    faq4Answer:
      'Yes, you can limit the request to individual rooms, basements or attics in Stuttgart – the companies will create a suitable quote.',
    faq5Question: 'What happens to reusable items in Stuttgart?',
    faq5Answer:
      'Valuable or reusable items can be sorted out in advance. Discuss details directly with the chosen {cityAdjEn} company.',
    ctaTitle: 'Ready for your disposal in Stuttgart?',
    ctaSubtitle:
      'Create your free request now and receive quotes from vetted Stuttgart disposal companies.',
    ctaPrimary: 'Create Request Now',
    ctaSecondary: 'View Stuttgart Companies',
  },
  disposalStuttgartDirectory: {
    metaTitle: 'Disposal Companies Stuttgart | RegionalUmzug24 – Compare Stuttgart Firms',
    metaDescription:
      'List of vetted disposal companies in Stuttgart. Compare ratings, specialties and prices of Stuttgart providers in postal code area 70.',
    metaKeywords:
      'disposal companies Stuttgart, Stuttgart disposal company, disposal Stuttgart firms',
    pageTitle: 'Disposal Companies in Stuttgart',
    pageSubtitle:
      'Discover vetted Stuttgart disposal companies with real reviews. Postal code area 70 – tailored to Stuttgart.',
    filterTitle: 'Filters',
    filterPremium: 'Premium companies only',
    filterVerified: 'Verified companies only',
    filterPostalTitle: 'Postal code area',
    filterPostalAll: 'All postal code areas',
    sortTitle: 'Sort by',
    sortRating: 'Best rating',
    sortOrders: 'Most orders',
    sortNewest: 'Newest',
    resultCount: '{{count}} companies found',
    emptyTitle: 'No companies found',
    emptyDescription:
      'No Stuttgart disposal companies match the current filters. Try adjusting the filters.',
    emptyReset: 'Reset filters',
    loadingTitle: 'Loading Stuttgart disposal companies...',
    errorTitle: 'Error loading',
    errorDescription:
      'The list of Stuttgart disposal companies could not be loaded. Please try again.',
    errorRetry: 'Retry',
    paginationPrev: 'Previous',
    paginationNext: 'Next',
    paginationPage: 'Page {{page}} of {{total}}',
    filterPostal70: 'PLZ 70 (Talkessel)',
  },
  cleaningBerlinLanding: {
    metaTitle: 'Cleaning Berlin | RegionalUmzug24 – Compare Cleaning companies',
    metaDescription:
      'Find vetted cleaning companies in Berlin. Compare free quotes from verified Berlin providers with experience in all 12 districts, from Mitte to Köpenick.',
    metaKeywords:
      'Cleaning Berlin, cleaning company Berlin, cleaning costs Berlin, cleaning Charlottenburg, cleaning Friedrichshain',
    heroTitleStart: 'Your cleaning in',
    heroTitleHighlight: 'Berlin.',
    heroSubtitle:
      'Compare vetted Berlin cleaning companies for free – fast, discreet and experienced in Mitte, Charlottenburg, Friedrichshain-Kreuzberg, Pankow and every other district.',
    heroCtaPrimary: 'Get Free Quotes',
    heroCtaSecondary: 'View Berlin Companies',
    heroStatFirms: '180+ Berlin companies',
    heroStatMoves: '320+ matched jobs',
    heroStatRating: '4.8/5 rating',
    benefitsTitle: 'Your benefits with RegionalUmzug24 for cleaning in Berlin',
    benefitsSubtitle: 'Why Berlin customers choose our matching platform',
    benefitFreeTitle: '100% free of charge',
    benefitFreeDesc:
      'Submitting a request and comparing quotes is completely free and non-binding.',
    benefitVettedTitle: 'Vetted Cleaning Pros',
    benefitVettedDesc:
      'We match only vetted Berlin cleaning companies with insurance and certification.',
    benefitFastTitle: 'Fast Appointments',
    benefitFastDesc:
      'Receive quotes within 24 hours and book your preferred date – even short notice.',
    servicesTitle: 'Our cleaning services in Berlin',
    servicesSubtitle: 'What kind of cleaning do you need in Berlin?',
    serviceApartmentTitle: 'Apartment Cleaning',
    serviceApartmentDesc:
      'Thorough cleaning of your Berlin apartment – perfect before or after a move in Mitte, Charlottenburg or Pankow.',
    serviceSecondaryTitle: 'Office Cleaning',
    serviceSecondaryDesc:
      'Regular or one-off professional cleaning of your Berlin office – also in Mitte and around Hackescher Markt.',
    serviceThirdTitle: 'Move-Out Cleaning',
    serviceThirdDesc:
      'Broom-clean handover of your Berlin apartment including acceptance guarantee with the landlord – in every district.',
    serviceFourthTitle: 'Window Cleaning',
    serviceFourthDesc:
      'Streak-free windows, frames and sills in Berlin – including hard-to-reach heights and Wilhelminian-style period flats.',
    processTitle: 'How your cleaning in Berlin works',
    processSubtitle: 'In three simple steps to the right cleaning company in Berlin',
    step1Title: 'Submit a request',
    step1Desc:
      'Describe your cleaning need in Berlin in just a few steps online – with district and preferred date.',
    step2Title: 'Receive Berlin quotes',
    step2Desc: 'Suitable cleaning companies from your Berlin district send you their offers.',
    step3Title: 'Choose a company',
    step3Desc: 'Compare ratings and pick the best cleaning offer in Berlin.',
    statsTitle: 'Cleaning in Berlin by the numbers',
    statsSubtitle: 'Berlin customers trust RegionalUmzug24',
    statFirms: '180+',
    statFirmsLabel: 'Berlin cleaning companies',
    statJobs: '320+',
    statJobsLabel: 'Matched jobs',
    statRating: '4.8/5',
    statRatingLabel: 'Customer rating',
    trustTitle: 'Vetted Berlin cleaning companies',
    trustSubtitle: 'Safety and quality – tailored to Berlin',
    trustVerifiedTitle: 'Verified Berlin companies',
    trustVerifiedDesc:
      'Every company is checked for business registration, insurance and cleaning experience.',
    trustGdprTitle: 'GDPR compliant',
    trustGdprDesc: 'Your data is transmitted securely and never shared with third parties.',
    trustFreeTitle: '100% free',
    trustFreeDesc: 'Using RegionalUmzug24 is completely free for you – no hidden fees.',
    faqTitle: 'Frequently asked questions about cleaning in Berlin',
    faqSubtitle: 'Answers to the most common questions about cleaning in Berlin',
    faq1Question: 'How much does cleaning in Berlin cost?',
    faq1Answer:
      'The cost depends on size, condition and district. Through us you will receive free comparable quotes from Berlin.',
    faq2Question: 'Are cleaning companies in Berlin insured?',
    faq2Answer:
      'Yes, all matched {cityAdjEn} cleaning companies are vetted and have liability insurance. You are covered in case of damage.',
    faq3Question: 'How fast will I receive Berlin quotes?',
    faq3Answer:
      'Usually you will receive the first quotes from suitable cleaning companies in Berlin and surroundings within 24 hours.',
    faq4Question: 'Can I book a short-notice cleaning in Berlin?',
    faq4Answer:
      'Yes, many cleaning companies in Berlin also offer short-notice appointments. Simply enter your preferred date in the request.',
    faq5Question: 'Which cleaning services are offered in Berlin?',
    faq5Answer:
      'From apartment cleaning to office, window and carpet cleaning – the matched companies cover the full spectrum.',
    ctaTitle: 'Ready for your cleaning in Berlin?',
    ctaSubtitle:
      'Create your free request now and receive quotes from vetted Berlin cleaning companies.',
    ctaPrimary: 'Create Request Now',
    ctaSecondary: 'View Berlin Companies',
  },
  cleaningBerlinDirectory: {
    metaTitle: 'Cleaning Companies Berlin | RegionalUmzug24 – Compare Berlin Firms',
    metaDescription:
      'List of vetted cleaning companies in Berlin. Compare ratings, specialties and prices of Berlin providers in postal code area 10-14.',
    metaKeywords:
      'cleaning companies Berlin, Berlin cleaning company, cleaning Berlin firms, cleaning Mitte, cleaning Charlottenburg',
    pageTitle: 'Cleaning Companies in Berlin',
    pageSubtitle:
      'Discover vetted Berlin cleaning companies with real reviews. Postal code area 10-14 – from Mitte to Köpenick.',
    filterTitle: 'Filters',
    filterPremium: 'Premium companies only',
    filterVerified: 'Verified companies only',
    filterPostalTitle: 'Postal code area',
    filterPostalAll: 'All postal code areas',
    sortTitle: 'Sort by',
    sortRating: 'Best rating',
    sortOrders: 'Most orders',
    sortNewest: 'Newest',
    resultCount: '{{count}} companies found',
    emptyTitle: 'No companies found',
    emptyDescription:
      'No Berlin cleaning companies match the current filters. Try adjusting the filters.',
    emptyReset: 'Reset filters',
    loadingTitle: 'Loading Berlin cleaning companies...',
    errorTitle: 'Error loading',
    errorDescription:
      'The list of Berlin cleaning companies could not be loaded. Please try again.',
    errorRetry: 'Retry',
    paginationPrev: 'Previous',
    paginationNext: 'Next',
    paginationPage: 'Page {{page}} of {{total}}',
    filterPostal10: 'PLZ 10 (Mitte, Charlottenburg)',
    filterPostal11: 'PLZ 11 (Tiergarten, Friedrichshain)',
    filterPostal12: 'PLZ 12 (Neukölln, Tempelhof, Steglitz)',
    filterPostal13: 'PLZ 13 (Pankow, Weißensee, Reinickendorf)',
    filterPostal14: 'PLZ 14 (Wilmersdorf, Zehlendorf, Köpenick)',
  },
  disposalBerlinLanding: {
    metaTitle: 'Clearance & Disposal Berlin | RegionalUmzug24 – Compare Disposal companies',
    metaDescription:
      'Find vetted disposal companies in Berlin. Compare free quotes from verified Berlin providers with experience in all 12 districts and with BSR bulky waste.',
    metaKeywords:
      'Clearance & Disposal Berlin, disposal company Berlin, disposal costs Berlin, BSR bulky waste Berlin',
    heroTitleStart: 'Your disposal in',
    heroTitleHighlight: 'Berlin.',
    heroSubtitle:
      'Compare vetted Berlin disposal companies for free – fast, discreet and experienced across all 12 districts, including BSR bulky-waste collection.',
    heroCtaPrimary: 'Get Free Quotes',
    heroCtaSecondary: 'View Berlin Companies',
    heroStatFirms: '140+ Berlin companies',
    heroStatMoves: '270+ matched jobs',
    heroStatRating: '4.7/5 rating',
    benefitsTitle: 'Your benefits with RegionalUmzug24 for disposal in Berlin',
    benefitsSubtitle: 'Why Berlin customers choose our matching platform',
    benefitFreeTitle: '100% free of charge',
    benefitFreeDesc:
      'Submitting a request and comparing quotes is completely free and non-binding.',
    benefitVettedTitle: 'Vetted Disposal Specialists',
    benefitVettedDesc:
      'We match only vetted Berlin disposal companies with insurance and certification.',
    benefitFastTitle: 'Fast Appointments',
    benefitFastDesc:
      'Receive quotes within 24 hours and book your preferred date – even short notice.',
    servicesTitle: 'Our disposal services in Berlin',
    servicesSubtitle: 'What kind of disposal do you need in Berlin?',
    serviceApartmentTitle: 'Apartment Clearance',
    serviceApartmentDesc:
      'Complete or partial clearance of your Berlin apartment including proper disposal and BSR de-registration.',
    serviceSecondaryTitle: 'House Clearance',
    serviceSecondaryDesc:
      'Full household clearance in Berlin – sensitive, discreet and with disposal certificate for inheritance or care-home moves.',
    serviceThirdTitle: 'Basement & Attic Clearance',
    serviceThirdDesc:
      'Finally space in your basement and attic in Berlin – including bulky and hazardous waste collection in your district.',
    serviceFourthTitle: 'Garden Clearance',
    serviceFourthDesc:
      'Removal of garden waste, old furniture and debris in Berlin – including transport to BSR recycling centres.',
    processTitle: 'How your disposal in Berlin works',
    processSubtitle: 'In three simple steps to the right disposal company in Berlin',
    step1Title: 'Submit a request',
    step1Desc:
      'Describe your disposal need in Berlin in just a few steps online – with district and preferred date.',
    step2Title: 'Receive Berlin quotes',
    step2Desc: 'Suitable disposal companies from your Berlin district send you their offers.',
    step3Title: 'Choose a company',
    step3Desc: 'Compare ratings and pick the best disposal offer in Berlin.',
    statsTitle: 'Disposal in Berlin by the numbers',
    statsSubtitle: 'Berlin customers trust RegionalUmzug24',
    statFirms: '140+',
    statFirmsLabel: 'Berlin disposal companies',
    statJobs: '270+',
    statJobsLabel: 'Matched jobs',
    statRating: '4.7/5',
    statRatingLabel: 'Customer rating',
    trustTitle: 'Vetted Berlin disposal companies',
    trustSubtitle: 'Safety and quality – tailored to Berlin',
    trustVerifiedTitle: 'Verified Berlin companies',
    trustVerifiedDesc:
      'Every company is checked for business registration, insurance and disposal experience.',
    trustGdprTitle: 'GDPR compliant',
    trustGdprDesc: 'Your data is transmitted securely and never shared with third parties.',
    trustFreeTitle: '100% free',
    trustFreeDesc: 'Using RegionalUmzug24 is completely free for you – no hidden fees.',
    faqTitle: 'Frequently asked questions about disposal in Berlin',
    faqSubtitle: 'Answers to the most common questions about disposal in Berlin',
    faq1Question: 'How much does clearance in Berlin cost?',
    faq1Answer:
      'The cost depends on volume, floor and district. Through us you will receive free comparable quotes from Berlin.',
    faq2Question: 'Is the waste properly disposed of in Berlin?',
    faq2Answer:
      'Yes, all matched {cityAdjEn} companies dispose of waste properly with certificate. Recyclables are recycled, residual waste is properly disposed of via BSR.',
    faq3Question: 'How fast can clearance in Berlin happen?',
    faq3Answer:
      'Usually you will receive the first quotes within 24 hours. Many {cityAdjEn} companies offer appointments within a few days.',
    faq4Question: 'Can I have only individual rooms cleared in Berlin?',
    faq4Answer:
      'Yes, you can limit the request to individual rooms, basements or attics in Berlin – the companies will create a suitable quote.',
    faq5Question: 'What happens to reusable items in Berlin?',
    faq5Answer:
      'Valuable or reusable items can be sorted out in advance. Discuss details directly with the chosen {cityAdjEn} company.',
    ctaTitle: 'Ready for your disposal in Berlin?',
    ctaSubtitle:
      'Create your free request now and receive quotes from vetted Berlin disposal companies.',
    ctaPrimary: 'Create Request Now',
    ctaSecondary: 'View Berlin Companies',
  },
  disposalBerlinDirectory: {
    metaTitle: 'Disposal Companies Berlin | RegionalUmzug24 – Compare Berlin Firms',
    metaDescription:
      'List of vetted disposal companies in Berlin. Compare ratings, specialties and prices of Berlin providers in postal code area 10-14.',
    metaKeywords:
      'disposal companies Berlin, Berlin disposal company, disposal Berlin firms, household clearance Berlin, BSR bulky waste',
    pageTitle: 'Disposal Companies in Berlin',
    pageSubtitle:
      'Discover vetted Berlin disposal companies with real reviews. Postal code area 10-14 – from Mitte to Köpenick.',
    filterTitle: 'Filters',
    filterPremium: 'Premium companies only',
    filterVerified: 'Verified companies only',
    filterPostalTitle: 'Postal code area',
    filterPostalAll: 'All postal code areas',
    sortTitle: 'Sort by',
    sortRating: 'Best rating',
    sortOrders: 'Most orders',
    sortNewest: 'Newest',
    resultCount: '{{count}} companies found',
    emptyTitle: 'No companies found',
    emptyDescription:
      'No Berlin disposal companies match the current filters. Try adjusting the filters.',
    emptyReset: 'Reset filters',
    loadingTitle: 'Loading Berlin disposal companies...',
    errorTitle: 'Error loading',
    errorDescription:
      'The list of Berlin disposal companies could not be loaded. Please try again.',
    errorRetry: 'Retry',
    paginationPrev: 'Previous',
    paginationNext: 'Next',
    paginationPage: 'Page {{page}} of {{total}}',
    filterPostal10: 'PLZ 10 (Mitte, Charlottenburg)',
    filterPostal11: 'PLZ 11 (Tiergarten, Friedrichshain)',
    filterPostal12: 'PLZ 12 (Neukölln, Tempelhof, Steglitz)',
    filterPostal13: 'PLZ 13 (Pankow, Weißensee, Reinickendorf)',
    filterPostal14: 'PLZ 14 (Wilmersdorf, Zehlendorf, Köpenick)',
  },
};

i18n.addResourceBundle('de', 'translation', deResources, true, true);
i18n.addResourceBundle('en', 'translation', enResources, true, true);

export default i18n;
